import React, {Component, useState} from "react";
import * as prosConnect from "../prodect/ProsConnect";
import {
    getRemainingTimeToText,
    strYesNoValue,
    renderNoCapacity,
    formatDate,
    PRODECT_DEFAULT_EMAIL_MSG,
    whyEmailStringNotValid,
    MakeWebLinkToClipBoard,
    SidePanel,
    renderObsAttachments,
    stateIcon,
    isEnumSelectionType,
    getTextFieldText,
    isMultiEnumSelectionType,
    TEXT_FIELD_WHEN_MISSING,
    FloatButton,
    UiIcon
} from "../prodect/ProsCommonUi";
import RenderReport from "./RenderReport"
import {prosNotificationShow} from "../prodect/ProsPopup";
import {
    ATTR_EXPORT_WEB_REPORT,
    ATTR_OBJ_TYPE,
    ATTR_TEXT,
    FEAT_PROMPT_REPORT_REC,
    featureEnabled,
    getActiveProject,
    getObjAttr,
    getObjById,
    OBJ_TYPE_ITM_TITLE,
    REPORT_TYPE_HISTORY,
    REPORT_TYPE_SEARCH,
    REPORT_TYPE_UPDATED,
    STR_NO,
    FEAT_WEB_UPDATED,
    awaitTableFilteredObs,
    savePdashMeter,
    OBJ_TYPE_ITM_OBS,
    VIEW_MODE_LIST,
    VIEW_MODE_TABLE,
    VIEW_MODE_CALENDAR,
    VIEW_MODE_DASHBOARD,
    awaitMakeProjectLink,
    VIEW_MODE_KANBAN,
    isValueEmpty,
    setSelectedReportIds,
    ATTR_IS_REPORTS_ALLOWED, ATTR_OBJ_STATE, OBJ_STATE_ACT,
} from "../prodect/ProsConnect";
import * as projectLoader from "../prodect/ProjectLoader";
import TextInput, {TimerTextInput} from "../components/TextInput";
import {
    prosPopupClose, prosPopupCloseAll,
    prosPopupOpenDynamic, prosPopupOpenPromptText,
    prosPopupRender
} from "../prodect/ProsPopup";
import {prosLog} from "../prodect/ProsConnect";
import {ATTR_OBJ_ID} from "../prodect/ProsConnect";
import {STR_YES} from "../prodect/ProsConnect";
import {getCopyMoveManager} from "../prodect/CopyMoveManager";
import {OBJ_TYPE_ITM} from "../prodect/ProsConnect";
import ProsRbTagMenu from "../prodect/ProsRbTagMenu";
import ProsTxtTagMenu from "../prodect/ProsTxtTagMenu"
import {STR_NO_VALUE} from "../prodect/ProsConnect";
import {prosLogWrn, prosLogErr} from "../prodect/ProsConnect";
import {ATTR_EXPIRATION} from "../prodect/ProsConnect";
import {OBJ_TYPE_LST} from "../prodect/ProsConnect";
import {OBJ_TYPE_LST_SEARCH, OBJ_TYPE_LST_SEARCH_R} from "../prodect/ProsConnect";
import {ATTR_CREATED_MS_I} from "../prodect/ProsConnect";
import {TAG_RB_PREFIX, TAG_TXT_PREFIX} from "../prodect/ProsConnect";
import LocationPictureList from "./LocationPictureList";
import {
    ProjectReportTable,
    OptionDropdown,
    CheckDropdown,
    RemainingTimeNumPicker,
    restoreTableSettings,
    SAVED_HIDDEN_COLS,
    SAVED_COL_ORDER,
    getColumnWidth,
    PROS_TBL_DEFAULT_WIDTH,
    clearToDefaultTableSettings,
    resetPageNumber,
    getSavedTableSetting,
    TABLE_DEFAULT_HIDDEN_COLS,
    getReadOnlyTableRows,
    clearColumnWidthCache,
    setTableFilter,
    setTableSort,
    getTableFilter,
    getTableSort,
    FLT_RANGE_WEEK, FLT_RANGE_DAY, dumpTableFilter, MandatoryMissingNumPicker, DateFilter
} from "./ProjectReportTable";

import {sendPdfRequest} from "../prodect/SearchManagement";
import {setHelpContext} from "../prodect/HelpManager";
import {getLinkAddr} from "../prodect/ProsLink";
import {SaveBookMarkDialog, BookMarksMenu} from "./Bookmarks";

import ScheduleMatrix, {maySendCalendarPdf} from "./ScheduleMatrix";
import ProsReportsButton from "../prodect/ProsReportsButton";
import Dashboard from "./Dashboard";
import DropdownMenu from "../components/DropdownMenu";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import RadioButton from "../components/RadioButton";
import Spacer from "../components/Spacer";
import PdfReportOptions from "../containers/PdfReportOptions";
import {USE_DEVELOPMENT_FEATURES} from "../config";
import prosAppNotif, {
    prosAppNotifConfirm,
    prosAppNotifDismiss,
    prosAppNotifWait,
    prosAppNotifWarn, prosAppNotifWarnConfirm,
    prosAppNotifNotice
} from "../prodect/ProsAppNotif";
import LoadingAnimation from "../components/LoadingAnimation";
import ToggleSwitch from "../components/ToggleSwitch";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";
import ProsDate from "../prodect/ProsDate";
import ProsEnumMenu from "../prodect/ProsEnumMenu";

export const OBS_TITLE = 'Kirjaus'
export const UI_OBS_TITLE = 'ui_text'
export const UI_IS_REPORT = 'ui_is_report'
export const UPDATED_BY_TITLE = "ui_lastUpdatedBy"
export const UPDATED_TIME_TITLE = 'ui_lastUpdatedMs'

const MAX_NUM_OF_OBS_TO_AUTO_OPEN_REPORT = 100;
const MAX_REPORTS_STRIP_VISIBLE = 10;
export const MAX_REPORTS_POPUP_VISIBLE = 18;
const DELAY_FOR_OBS_FOCUS_MS = 1000;
const VIEW_ID_FOR_SUBSCRIBE = "ProjectReports"

// Note 7.6.2021 - removed cell copy by dragging due to
//      - Windows browsers do not support table scrolling by mouse wheel while pressing left button
//        that would limit copying for visible part of table
//      - With high number of rows browser get very slow / laggy to call onDragEnter() - barely usable for > 100 rows
//        especially as there is no way to indicate "busy" when releasing mouse button

// Note 4.5.2022 - removed cell copy unused code to support "copy by dragging"

var prevObsFromLink

// Remember report selection name filter
let reportSelectionTextFilter = ''
let reportSelectionPid = undefined

// todo - filtterin asettaminen vaikka ei yhtään riviä


// TODO - move these to Home
// Session time UI mode
let savedUiMode = {
    viewMode: undefined,    // dashboard | list | table | matrix or undefined after browser hard refresh
    isSearchMode: false,    // some reports or one search
    filterText: '',         // list and calendar mode - text filter
    showCommentsInTable: false,  // to get from link is chosen to show comments in table
    showFulltextInTable: false,  // to get from link is chosen to show comments in table
    useTableMultiSelectAutoColor: false,     // To show multiselect table columns with color when manual color missing
}

export function getFilterText() {
    return savedUiMode.filterText
}

export function resetToNormalReportMode() {
    savedUiMode.isSearchMode = false
}

export function setSavedViewMode(uiModeFromLink, uiSettings) {
    savedUiMode = uiModeFromLink
    savedUiMode['showCommentsInTable'] = uiSettings['showCommentsInTable']
    savedUiMode['showFulltextInTable'] = uiSettings['showFulltextInTable']
    savedUiMode['useTableMultiSelectAutoColor'] = uiSettings['useTableMultiSelectAutoColor']
}

function showMeterByExpirationDate(meterSettings) {
    return ((meterSettings[ATTR_OBJ_TYPE] === "meter_readiness") ||
        (meterSettings[ATTR_OBJ_TYPE] === "meter_gantt") ||
        (meterSettings[ATTR_OBJ_TYPE] === "meter_cumulative" && meterSettings.viewBy === "expiration"))
}

/**
 * To choose table sort order based on meter settings
 * @param meterSettings - ref meter
 */
function getTableSortingForMeter(meterSettings) {
    if (showMeterByExpirationDate(meterSettings)) {
        // sort by expiration
        return [{
            "id": "ui_expires",
            "desc": true}]
    }
    if (meterSettings[ATTR_OBJ_TYPE] === "meter_cumulative") {
        return [{
            "id": ATTR_CREATED_MS_I,
            "desc": true}]
    }
    // Default - sort most recently modified
    return [{
        "id": UPDATED_TIME_TITLE,
        "desc": true}]
}

/**
 * To choose default table filter based on meter settings
 * @param meterSettings - ref meter
 */
function getTableFilterForMeter(meterSettings) {
    if (showMeterByExpirationDate(meterSettings)) {
        return [{id: "ui_expires", value: [946684800000, null]}]
    }
    return []
}

export default class ProjectReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDataPreparedForTable: false,
            uiListRefreshed: 0,     // Inform clients about UI list been changed
            filterTextInput: '',
            dataForTable: [],
            columnsForTable: [],
            selectedObsId: '',
            chosenObs: [],
            dragState: false,
            cellEdit: undefined,
            showingSearchList: savedUiMode.isSearchMode,
            showCommentsInTable: savedUiMode.showCommentsInTable,
            showFulltextInTable: savedUiMode.showFulltextInTable,
            useTableMultiSelectAutoColor: savedUiMode.useTableMultiSelectAutoColor,
            refreshCounter: 0,
            currentWeek: undefined,
            currentDay: undefined,
            currentMonth: undefined,
            currentYear: undefined,
            timeSet: false,
            selectedRow: null,
            locationPictureHash: '',
            locationPictureListVisibility: false,
            draggedColumnId: undefined,
            columnIdOrder: [],          // Column order for editing
            columnOrderForTable: [],    // Column order for table
            markCopyFrom: undefined,    // Copy in table src
            markCopyTo: undefined,      // Copy in table dst
            listReversed: false,
            showColumnFilters: false,
            isHelpContextByUiMode: false,
            disableShowingReportSelection: false,
            showTagStrip: false,
            previousSearchStat: undefined,
            showSidepanel: false,
        };
        this.uiList = null;
        this.itemSelected = this.itemSelected.bind(this);
        this.refreshUi = this.refreshUi.bind(this);
        this.goBack = this.goBack.bind(this);
        this.clearTextFilter = this.clearTextFilter.bind(this);
        this.notifFromReport = this.notifFromReport.bind(this);
        this.gotoPage = this.gotoPage.bind(this);
        this.setActiveObsFromLocationPictureList = this.setActiveObsFromLocationPictureList.bind(this);
        this.toggleVisibilityOfLocationPictureList = this.toggleVisibilityOfLocationPictureList.bind(this);
        // this.handleEmail = this.handleEmail.bind(this);
        // this.handleEmailText = this.handleEmailText.bind(this);
        this.latestSortAndFilter = {filter: undefined, sortBy: undefined}
        // this.reportsPopupListRef = React.createRef()
        this.savedTableSettings = undefined
    }

    updateUiListRefreshed(who) {
        this.setState({uiListRefreshed: this.state.uiListRefreshed+1})
    }

    refreshUi(why) {
        // prosLogX("PR: refreshUi() by:", why)
        if (this.state.markCopyFrom) {
            // Shall not refresh while marking table copy rows
            this.cancelTableCopyCells()
        }
        this.setState({refreshCounter: this.state.refreshCounter+1})
    }

    renderRefreshUi() {
        return <BasicButton
            icon={"sync"}
            tooltip={["Päivitä projektin tilanne", "tooltip-left_bottom"]}
            action={()=>{
                this.loadAndRefreshUi()
            }}
            loading={this.state.loadingUpdates}
        />
    }

    async loadAndRefreshUi() {
        this.setState({loadingUpdates: true});
        let changeCount = await prosConnect.getActiveProject().awaitRefreshProjectObjectsFromAws(true);
       if (changeCount > 0) {
           prosAppNotif("Päivitetty " + changeCount);
           this.refreshUi('loadAndRefreshUi');
       } else {
           prosAppNotif("Ei muutoksia");
       }
        this.setState({loadingUpdates: false});
    }

    componentDidMount() {
        // prosLogX('ProjectReports:componentDidMount() ++');
        dumpTableFilter(prosConnect.getActiveProjectID(), "ProjectReports componentDidMount")
        if (savedUiMode.isSearchMode && !getActiveProject()?.selectedSearchId) {
            // When UI is search mode but searchId is not set change from "search report" to "selected reports" #2.661
            savedUiMode.isSearchMode = false
            this.setState({showingSearchList: savedUiMode.isSearchMode})
        }
        getCopyMoveManager().setRearrangeMode(false)
        savedUiMode.viewMode = this.props.reportViewMode
        this.clearReportSelectionNameFilterOnProjectChange()
        this.reportViewModeChanged()
    }

    onProjectDataChanged(who, change) {
        // prosLogX('ProsReports:onProjectDataChanged() who:', who);
        if (this.props.reportViewMode === VIEW_MODE_DASHBOARD) {
            // Dashboard does not need UI data
            return
        }
        // Close side panel (OBS in focus) when OBS been deleted
        let obsFromDb = prosConnect.findObsById(this.state.selectedObsId)
        if (!obsFromDb || obsFromDb[ATTR_OBJ_STATE] !== OBJ_STATE_ACT) {
            this.closeSidePanel()
        }
        if (change && change.newObsId) {
            this.setFocusToObs(change.newObsId)
        }
        this.loadDataForUi()
    }

    /**
     * Close reports when search report or text filter has been changed in list view mode
     */
    autoCloseOpenReports(changedSearchStats) {
        this.uiList.forEach (report => {
            // When changed search report or filter close report obs
            prosConnect.clearUiStatesForReport(report)
            // auto open report when not too many OBS in search result
            report.ui_isOpen = changedSearchStats.matchingObsCount < MAX_NUM_OF_OBS_TO_AUTO_OPEN_REPORT
        })
    }

    loadDataForUi() {
        let project = prosConnect.getActiveProject()
        if (!project) {
            return
        }
        let takeAllReportItems =
            (savedUiMode.filterText !== '' && this.props.reportViewMode === VIEW_MODE_LIST) || savedUiMode.isSearchMode
        let takeEmptyReports = [VIEW_MODE_CALENDAR, VIEW_MODE_KANBAN].includes(this.props.reportViewMode)
        this.uiList = project
            .getUiList(undefined, savedUiMode.filterText,
                savedUiMode.isSearchMode, takeAllReportItems, takeEmptyReports)
        let changedSearchStat = project.getChangedSearchStat(this.state.previousSearchStat)
        if (changedSearchStat) {
            this.setState({previousSearchStat: prosConnect.copyJsObj(changedSearchStat)})
            if (this.props.reportViewMode === VIEW_MODE_LIST) {
                this.autoCloseOpenReports(changedSearchStat)
            }
        }
        if (this.props.reportViewMode === VIEW_MODE_TABLE) {
            this.setDataForTable(prosConnect.getActiveProject())
        }
        this.updateUiListRefreshed("loadDataForUi")
    }

    updateStateFromSavedUiMode(stateAttr, savedUiModeAttr) {
        // Restore some view settings from link via "savedUiMode" and save there to make a new link
        // "viewmode" is restored from link and provided by Home using props
        // Other view settings can be changed locally
        if (this.state[stateAttr] !== savedUiMode[savedUiModeAttr] && stateAttr !== "viewMode") {
            this.setState({[stateAttr]: savedUiMode[savedUiModeAttr]})
            return true
        }
        return false
    }

    scrolltoElementById(id){
        const el = document.getElementById(id);
        if(el) {
            el.scrollIntoView()
        }
    }

    /**
     * Opens OBS panel in table and calendar or opens (and scrolls) to that in list view
     * Used for OBS URL link and internally by float add obs button
     * @param obsId     either OBS DB object id or its visible identifier
     */
    setFocusToObs(obsId) {
        let obs = prosConnect.findObsById(obsId)
        if (obs) {
            prosLog("Set focus to OBS:", obsId)
            obs.ui_isOpen = true
            switch (this.props.reportViewMode) {
                case VIEW_MODE_LIST: {
                    let reportId = prosConnect.getObjListIdFromItemId(obs[ATTR_OBJ_ID])
                    let report = prosConnect.getObjById(reportId)
                    if (report) {
                        report.ui_isOpen = true
                    }
                    prosAppNotifWait("Hetkinen..")
                    setTimeout(() => {
                        this.scrolltoElementById("focus-" + obs[ATTR_OBJ_ID])
                        prosAppNotifDismiss()
                    }, DELAY_FOR_OBS_FOCUS_MS)
                    break
                }
                case VIEW_MODE_TABLE:
                {
                    this.setState({
                        showSidepanel: true,
                        selectedObsId: obs[ATTR_OBJ_ID],
                        chosenObs: [obs],
                        selectedRow: null
                    })
                    break
                }
                case VIEW_MODE_CALENDAR:
                case VIEW_MODE_KANBAN:
                    {
                        this.setState({
                            showSidepanel: true,
                            selectedObsId: obs[ATTR_OBJ_ID],
                            chosenObs: [obs]
                        })
                        break
                    }
                default: {
                    prosLogWrn("No focus to OBS due to unknown view:", this.props.reportViewMode)
                    return
                }
            }
            prevObsFromLink = obsId
        } else {
            prosLogWrn("NOT found obsIdFromLink:", obsId)
        }
    }

    checkToFocusOnObsLink() {
        // App opened with OBS link - check if already loaded ( due to incremental load may come later )
        let obsIdFromLink = prosConnect.getObsIdFromLink()
        if (obsIdFromLink && obsIdFromLink !== prevObsFromLink) {
            this.setFocusToObs(obsIdFromLink)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // savedUiMode is used to restore configuration from sessionStore
        //      - last used mode for project when navigate between projects
        //      - get mode etc from project link or bookmark
        this.updateStateFromSavedUiMode('showingSearchList', 'isSearchMode')
        this.updateStateFromSavedUiMode('filterTextInput', 'filterText')
        this.updateStateFromSavedUiMode('showCommentsInTable', 'showCommentsInTable')
        this.updateStateFromSavedUiMode('showFulltextInTable', 'showFulltextInTable')
        this.updateStateFromSavedUiMode('useTableMultiSelectAutoColor', 'useTableMultiSelectAutoColor')

        // Actions when view mode been changed
        if (this.isViewModeChanging()) {
            // prosLogX("componentDidUpdate: view mode changing", savedUiMode.viewMode, "->", this.props.reportViewMode)
            this.reportViewModeChanged()
        } else {
        }

        // when opened from OBS url link open selected OBS when loaded
        this.checkToFocusOnObsLink()
    }

    componentWillUnmount() {
        getCopyMoveManager().setRearrangeMode(false)
        prosConnect.registerToRetrieveViewSettings(this.props.reportViewMode, undefined)
        projectLoader.unSubscribeRefreshUiWhenDataChanged( VIEW_ID_FOR_SUBSCRIBE)
        prosPopupCloseAll()
    }

    itemSelected(item) {
        prosLog('Selected item ', item.obj_id, item.obj_type);
        let isReportOrSearch = item.obj_type.indexOf(OBJ_TYPE_LST) === 0
        if (!isReportOrSearch) {
            return
        }
        prosConnect.isReportToSelect(item, 'ProjectReport:itemSelected()')
    }

    goBack() {  // todo check
        this.props.history.goBack();
    }

    renderSelectReportOrSearchList(){
        if(this.props.reportViewMode === VIEW_MODE_DASHBOARD ||
           this.state.disableShowingReportSelection) {
            return null
        }
        let project = prosConnect.getActiveProject()
        if (!project || this.props.reportViewMode === VIEW_MODE_DASHBOARD) {
            return null
        }
        return this.renderReportToggles()
    }

    renderPageHeaderInfo() {
        return <div className={"element-set view-settings"}>
            <div className={"inline-flex"}>
                {this.renderSelectReportsButton(true)}
                {this.renderSelectReportOrSearchList()}
            </div>
            {[VIEW_MODE_LIST, VIEW_MODE_CALENDAR, VIEW_MODE_KANBAN]
                .includes(this.props.reportViewMode) ? this.renderTextFilter() : null}
            {this.renderReturnOrSaveSettings()}
        </div>
    }

    async execCopyOrMoveReport() {
        prosAppNotifWait("Raporttia kopioidaan")
        let newReportId = await getCopyMoveManager().awaitMarkedReportToActiveProject()
        let reportObj = prosConnect.getObjById(newReportId)
        if (reportObj) {
            prosConnect.isReportToSelect(reportObj, "execCopyOrMoveReport")
        }
        prosAppNotifDismiss()
        this.loadDataForUi()
        this.refreshUi('after report copy');
    }

    renderAddNewReportOrSearch() {
        if (this.props.reportViewMode !== VIEW_MODE_LIST) {
            return null
        }
        if (!prosConnect.getActiveProject()) {
            return null
        }
        if (!prosConnect.hasPermissionTo("addContent", undefined, undefined, false)) {
            return null
        }
        if (!getActiveProject().hasCapacityToAddItems(true)) {
            return renderNoCapacity(this.state.showingSearchList ? 'hakua' : 'raporttia')
        }
        if (!getCopyMoveManager().isCopyOrMoveReportMode()) {
            return null
        }
        let actionButtonTitle = ' valittu raportti tähän osaprojektiin'
        let cancelButtonTitle = 'Peru raportin '
        if (getCopyMoveManager().sourceObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
            actionButtonTitle = ' valittu kirjaus tähän osaprojektiin'
            cancelButtonTitle = 'Peru kirjauksen '
        }
        if (getCopyMoveManager().isCopyMode()) {
            actionButtonTitle = 'Kopioi' + actionButtonTitle
            cancelButtonTitle =  cancelButtonTitle + ' kopiointi'
        } else {
            actionButtonTitle = 'Siirrä' + actionButtonTitle
            cancelButtonTitle = cancelButtonTitle + ' siirto'
        }
        return <footer className={"page-footer"}>
            <div className={"btn-set_center"}>
                <CancelButton
                    label={cancelButtonTitle}
                    action={()=> {
                        getCopyMoveManager().clear()
                        prosAppNotifDismiss()
                        this.refreshUi("renderAddNewReportOrSearch")
                    }}
                />
                <ConfirmButton
                    label={actionButtonTitle}
                    action={()=> this.execCopyOrMoveReport()}
                />
            </div>
        </footer>
    }

    cancelAnyCopyOrMoveOperation() {
        getCopyMoveManager().cancelOperations()
        prosAppNotifDismiss()
        if (this.state.dragState) {
            this.toggleDragState()
        }
    }

    onFilterTextChanged(val) {
        savedUiMode.filterText = val
        this.setState({
            filterTextInput: val
        })
        if (val) {
            this.cancelAnyCopyOrMoveOperation()
        }
        prosLog('ListModeTextFilterChanged', val)
        this.filterObs()
    }

    // This gets called when user has changed a text filter
    filterObs() {
        let project = prosConnect.getActiveProject();
        if (!project) {
            return
        }
        this.loadDataForUi()
        if (project.isUiListLimitedBySize()) {
            prosAppNotifWarnConfirm("Liian monta hakuosumaa, raja: " +
                prosConnect.MAX_NUM_OF_UI_OBJS);
        }
    }

    clearTextFilter() {
        if (this.props.reportViewMode === VIEW_MODE_LIST) {
            prosConnect.getActiveProject().unSelectReports()
        }
        this.clearTextFilterText()
        this.refreshUi("clearTextFilter")
    }

    renderTextFilter(){
        // remove comment from next line to disable text filter for search mode #2.603
        // if(this.state.showingSearchList) return <div/>
        if(this.props.reportViewMode === VIEW_MODE_CALENDAR && prosConnect.selectedReportsAmount() < 1) {
            // Calendar - do not show text filter when no report been selected
            return null
        }
        if(prosConnect.getActiveProject().getReports().length < 1 && this.props.reportViewMode !== VIEW_MODE_LIST) return null
        return <TimerTextInput
            placeholder={this.props.reportViewMode === VIEW_MODE_CALENDAR ? 'Etsi valituista raporteista'
                : 'Etsi kaikista raporteista'}
            value={savedUiMode.filterText}
            isControlled={true}
            onInputChange={ () => {}}
            timerCallback={(val)=> {
                this.onFilterTextChanged(val)
            }}
        />
    }

    setDataForTable(project) {
        //prosLogClearDt('setDataForTable() - started');
        let dataForTable = project.uiItems;
        // dataForTable
        //      contains list of reports
        //      each report contains list of item 'obsList'
        //      each item is either
        //          title item
        //          text (comment) item
        //          picture item
        //          OBS - that contains
        //               list of OBS items 'obsObjList'
        //               list of OBS pictures 'ui_Picts'
        //
        // for table need a list of OBS - skip others

        let listOfObs = []
        let origRow = 0
        dataForTable.forEach(report => {
            if (report.obsList && report.obsList.length) {
                let latestTitle = ''
                let latestReport = ''
                report.obsList.forEach(obs => {
                    if (prosConnect.isObservation(obs)) {
                        let isSearchReport = report.obj_type === OBJ_TYPE_LST_SEARCH ||
                                             report.obj_type === OBJ_TYPE_LST_SEARCH_R
                        origRow++
                        obs.ui_report = isSearchReport
                            ? latestReport
                            : prosConnect.getReportInfo(report)
                        obs.ui_title = latestTitle;
                        this.setObsDataForTable(project, obs, origRow)
                        listOfObs.push(obs)
                    } else if (obs[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
                        latestTitle = getObjAttr(obs, ATTR_TEXT) === STR_NO_VALUE ?
                            latestTitle : getObjAttr(obs, ATTR_TEXT)
                    }
                    if (obs[UI_IS_REPORT]) {
                        latestReport = latestTitle
                    }
                });
            }
        });
        this.setState({
            dataForTable: listOfObs,
        });
        // prosLogDtX('setDataForTable() - completed');  // will show time in ms
    }

   openCreateNewObsPopup(e, obs_id) {
       e.stopPropagation()

       prosPopupOpenPromptText(this,
           'Luo kirjaus',
           'Anna kirjaukselle nimi',
           (text) => this.createNewObs(obs_id, text)
       )
   }

    async createNewObs(obs_id, name) {
        await prosConnect.getActiveProject().awaitAddObs(name, obs_id, obs_id)
        this.setState({promptText: null});
        prosPopupClose()
        prosAppNotif("Uusi kirjaus luotu")
    }

    async copyObs(e, obs_id) {
        e.stopPropagation()
        let afterObs = getObjById(obs_id)
        getCopyMoveManager().markCopySource(afterObs)
        prosAppNotifWait()
        await getCopyMoveManager().awaitCopy(afterObs)
        getCopyMoveManager().cancelOperations()
        prosAppNotif("Kirjaus kopioitu")
    }

    renderObsCellInTable(rowdata) {
        const row = rowdata.row.original
        let addObsButtons = prosConnect.hasPermissionTo("addContent", undefined, undefined, false)
            ?
            <div className={"tools"}>
                <BasicButton
                    icon={"ellipsis-v"}
                    size={"sm"}
                />
                <div className={"btn-set"}>
                    <BasicButton
                        btnClass={"primary"}
                        icon={"copy"}
                        action={(e)=>this.copyObs(e, row.obj_id)}
                        size={"sm"}
                        title={"Kopioi kirjaus"}
                    />
                    <BasicButton
                        btnClass={"primary"}
                        icon={"plus"}
                        action={(e)=>this.openCreateNewObsPopup(e, row.obj_id)}
                        size={"sm"}
                        title={"Luo uusi kirjaus"}
                    />
                </div>
            </div>
            : null
        return <>
            <div className={"td-obs-container"}>
                <div className={"text" + (this.state.showFulltextInTable ? " text-full" : "")}>{row.ui_text}</div>
                {addObsButtons}
            </div>
            {this.getObsComments(row)}
        </>
    }

    renderTableCellWithCopy(row, column, value, missingValue, classname, icon) {
        const hasPermissions = prosConnect.hasPermissionTo("editObj", undefined, undefined, false)
        return <div className={"table-cell-link" + (classname && classname !== "text" ? " " + classname : "")
                + (missingValue ? " missing-cell" : "")
                + (hasPermissions ? " drag-copy" : "")
                + (value == null && !missingValue ? " add-content" : "")}
                onClick={evt => {
                    if(!hasPermissions){
                        evt.stopPropagation()
                        prosAppNotifNotice("Ei käyttöoikeuksia")
                    }
                }}
            >
            {classname === "text" && !missingValue ? <div className={"text"}>{value}</div>
                : (missingValue && icon) || value === '_' ? <><i className={"ui-icon ui-icon-sm ui-icon-" + (icon || "asterisk") + " ui-icon_color-2nd"}/>{value !== '_' ? value : null}</> : value}
            {hasPermissions ?
                <div className={"btn-set"}>
                    <BasicButton
                        size={"xs"}
                        icon={"copy"}
                         action={() => {
                             this.markCopyStartOrEnd(row, column)
                         }}
                        title={"Monista solun arvo"}
                    />
                </div>
                : null
            }
        </div>
    }

    getTableColumnOrder(pid, defaultColumnIdOrder) {
        let columnOrderFromLocalStorage = getSavedTableSetting(localStorage, pid, SAVED_COL_ORDER, defaultColumnIdOrder)
        let newColumnsMissingFromSettings = defaultColumnIdOrder
            .filter(item => columnOrderFromLocalStorage.indexOf(item) < 0)
        if (!newColumnsMissingFromSettings) {
            return columnOrderFromLocalStorage
        }
        // add new columns before first fixed column
        let addNewColumnsPos = -1
        for (let fixedCol of prosConnect.TABLE_FIXED_COLS_AT_RIGHT) {
            addNewColumnsPos = columnOrderFromLocalStorage.findIndex(id => id === fixedCol)
            if (addNewColumnsPos >= 0) {
                break
            }
        }
        if (addNewColumnsPos < 0) {
            // no fixed columns - add to and of the column list
            return columnOrderFromLocalStorage.concat(newColumnsMissingFromSettings)
        }
        columnOrderFromLocalStorage.splice(addNewColumnsPos, 0, ...newColumnsMissingFromSettings)
        return columnOrderFromLocalStorage
    }

    renderSetDueDateButton(project, obs, ms, label, isMissing = false,  icon = null, iconColor = null){
        return <ProsDate
            obs={obs}
            timeMs={ms}
            isMissing={isMissing || (!ms && project.isExpirationDateMissing(obs))}
            label={label}
            useButtonTitle= {"Tallenna"}
            onTimeChanged={newTimeMs => this.saveObsAttr(ATTR_EXPIRATION, newTimeMs, obs)}
            hideIcon={!icon}
            icon={icon}
            iconColor={iconColor}
            iconSize={"sm"}
        />
    }

    setColumnsForTable(project) {
        let pid = project.getPid()
        let columnArray = [
            {
                Header: 'Raportti',
                accessor: "ui_report",
                Cell: (row) => {
                    return <div>{row.value}</div>
                },
                width: getColumnWidth(pid, 'ui_report'),
                filter: 'text',
            },
            {
                Header: 'Otsikko',
                accessor: "ui_title",
                Cell: (row) => {
                    return <div>{row.value}</div>
                },
                width: getColumnWidth(pid, 'ui_title'),
                filter: 'text',
            },
            {
                Header: OBS_TITLE,
                id: UI_OBS_TITLE,
                accessor: 'uiTextAndComments',
                className: 'sticky obs-table-td',
                width: getColumnWidth(pid, UI_OBS_TITLE, 2*PROS_TBL_DEFAULT_WIDTH),
                filter: 'uiTextAndComments',
                sortType: 'sortObs',        // OBS sorted by original row ID - not by text
                Cell: row => (
                    this.renderObsCellInTable(row)
                )
            },
            {
                Header: 'ObjId',
                accessor: 'ui_obj_id',
            },
            {
                Header: 'Määräaika',
                accessor: 'ui_expires',
                Cell: (props) => {
                    const {row} = props
                    const obs = row.original
                    const expirateMs = prosConnect.getExpiration(obs)
                    const isSet = expirateMs > 0 && !project.isExpirationDateMissing(obs)
                    const cellContent = this.renderSetDueDateButton(project, obs, expirateMs,  isSet ? obs.value : "",
                        !isSet,
                        isSet ? null : "asterisk",
                        isSet ? null : "2nd"
                    )
                    if (isSet) {
                        return this.renderTableCellWithCopy(row, props.column, cellContent, false,null)
                    } else if (row.original) {
                        return this.renderTableCellWithCopy(row, props.column, cellContent, true,null)
                    }
                    return ''
                },
                width: getColumnWidth(pid, 'ui_expires'),
                Filter: DateFilter,
                filter: 'betweenDates'
            },
            {
                Header: 'Aikaa jäljellä',
                accessor: "ui_timeToDate",
                Cell: (props) => {
                    const {row} = props
                    const obs = row.original
                    const expirateMs = prosConnect.getExpiration(obs)
                    let timeLeft = getRemainingTimeToText(expirateMs)
                    let isLate = timeLeft.startsWith('-')
                    if (expirateMs <= 0 || !prosConnect.isInStateOngoing(obs)) {
                        return null
                    } else {
                        return <div className={"table-cell-link"
                             + (isLate ? " color-no" : "")}>
                            {this.renderSetDueDateButton(project, obs, expirateMs, timeLeft, isLate,
                                isLate ? "alarm" : null, isLate ? "2nd" : null)}
                        </div>
                    }
                },
                width: getColumnWidth(pid, 'ui_timeToDate'),
                Filter: RemainingTimeNumPicker,
                filter: 'betweenNumbers',
            },
            this.getTagColumns(project),
            this.getCheckColumns(project),
            this.getTextColumns(project),
            {
                Header: 'Tekijä',
                accessor: "created_by",
                Cell: (row) => {
                    return <div>{row.value}</div>
                },
                width: getColumnWidth(pid, 'created_by'),
                filter: 'text'
            },
            {
                Header: 'Luotu',
                accessor: ATTR_CREATED_MS_I,
                Cell: (row) => {
                    return <span>{formatDate(row.value)}</span>
                },
                width: getColumnWidth(pid, ATTR_CREATED_MS_I),
                Filter: DateFilter,
                filter: 'betweenDates',
                sortType: 'sortTime',
            },
            {
                Header: 'Muokannut',
                accessor: UPDATED_BY_TITLE,
                Cell: (row) => {
                    return <div>{row.value}</div>
                },
                width: getColumnWidth(pid, UPDATED_BY_TITLE),
                filter: 'text'
            },
            {
                Header: 'Muokattu',
                accessor: UPDATED_TIME_TITLE,
                Cell: (row) => {
                    return <span>{formatDate(row.value)}</span>
                },
                width: getColumnWidth(pid, UPDATED_TIME_TITLE),
                Filter: DateFilter,
                filter: 'betweenDates',
                sortType: 'sortTime',
            },
            {
                Header: 'Puutteita',
                accessor: "ui_mandatoryMissing",
                Cell: (props) => {
                    const {row} = props
                    const obs = row.original
                    return <div className={"text-center"}>{project.countMissingMandatoryAttribute(obs)}</div>
                },
                width: getColumnWidth(pid, 'ui_mandatoryMissing'),
                Filter: MandatoryMissingNumPicker,
                filter: 'betweenNumbersMandatory',
                sortType: 'sortMandatory',
            },
        ].flat()
        let hiddenColumnsFromLocalStorage =
            getSavedTableSetting(localStorage, pid, SAVED_HIDDEN_COLS, TABLE_DEFAULT_HIDDEN_COLS)
        // Default columns all except ui_obj_id which is used for sorting by server
        let defaultColumnIdOrder = columnArray
            .map( e => e.id ? e.id : e.accessor)
            .filter(id => id !== "ui_obj_id")
        let columnIdOrder = this.getTableColumnOrder(pid, defaultColumnIdOrder)
        this.setState({
            columnsForTable: columnArray,
            columnIdOrder: columnIdOrder,
            columnOrderForTable: columnIdOrder,
            defaultColumnIdOrder: defaultColumnIdOrder,
            hiddenColumnIds: hiddenColumnsFromLocalStorage,
        })
    }

    getObsComments(obs) {
        if (!obs) return null
        let comments =
            obs.obsObjList
                .filter(itm => itm.obj_type === OBJ_TYPE_ITM)
                .map(itm => {
                    let itemText = prosConnect.getItemText(itm)
                    let link = getLinkAddr(itemText)
                    return link ? link.linkText ? link.linkText: link.link : itemText
                });
        let styledList = this.state.showCommentsInTable ? <div className={"cell-comments"}>{comments.map((comment, index) =>
                <div className="cell-comment" key={"k"+index}>
                    {comment}
                </div>)}
            </div> : null
        return <>
            {renderObsAttachments(obs, false)}
            {styledList}
        </>
}

    setObsDataForTable(project, obs, origRow) {
        let orig = prosConnect.getOriginal(obs);
        obs.ui_origRow = origRow
        // OBS id used for location picture reference
        obs.ui_obj_id = obs.obj_id;
        obs.ui_timeToDate = prosConnect.getExpirationQualified(orig);
        let expiresMs = prosConnect.getExpiration(orig);
        obs.ui_expires = expiresMs > 0 ? expiresMs : '';
    }

    // Multivalue / RB options
    getTagColumns(project) {
        let tagList = [];
        let pid = project.getPid()
        project.getRbTagTitles().forEach((label, i) => {
            let tagId = project.getRbTags()[i]
            tagList.push({
                Header: label,
                accessor: rowObs => {
                    let tagValue = prosConnect.getValidAttr(rowObs, tagId)
                    return tagValue !== undefined ? project.getRbTagLabels(i)[tagValue] : ''
                },
                id: tagId,
                Cell: (props) => {
                    const { row } = props;
                    let tagValue = prosConnect.getValidAttr(row.original, props.column.id)
                    if (project.isRbTagMandatory(props.column.id) && tagValue === undefined) {
                        return this.renderTableCellWithCopy(row, props.column, "_", true)
                    }
                    let value = project.getRbTagLabels(i)[tagValue]
                    if (props.column.id === project.getStateRbTag()) {
                        let renderValue = <span className={"icon-text-set-xs text-sm"}>{stateIcon(row.original, 'sm')}<span>{value}</span></span>
                        return this.renderTableCellWithCopy(row, props.column, renderValue)
                    }
                    return this.renderTableCellWithCopy(row, props.column, value)
                },
                Filter: OptionDropdown,
                filter: 'includesAndEmpty',
                width: getColumnWidth(pid, tagId),
                sortType: 'tagSortRb',
            });
        });
        return tagList
    }

    // Yes - no selections
    getCheckColumns(project) {
        let checkList = [];
        let pid = project.getPid()
        project.getChTagLabels().forEach((label, i) => {
            let tagId = project.getChTags()[i];     // "tag_ch" + i,
            checkList.push({
                Header: label,
                accessor: rowObs => {
                    let value = prosConnect.getValidAttr(rowObs, tagId)
                    return value ? value : STR_NO
                },
                id: tagId,
                Cell: (props) => {
                    const { row } = props
                    // Boolean string 'Y' | 'n'
                    let value = prosConnect.getValidAttr(row.original, props.column.id)
                    value = value ? value : STR_NO
                    let isUrgent = props.column.id === project.getUrgentChTag()
                    let showIfUrgent = isUrgent && prosConnect.isInStateOngoing(row.original)
                    let isChecked = value === STR_YES
                    let ddIcon = isUrgent && showIfUrgent && isChecked ? "urgent" : (isChecked ? "check" : "edit")
                    const cellContent = !project.getMayEditCheckBoxOrText(tagId)
                        ? (isChecked ? <UiIcon icon={ddIcon} size={"md"} className={"flex-center"} /> : null)
                        : <DropdownMenu
                            values={[
                                {
                                    icon: isChecked ? "times" : "check",
                                    action: () => {
                                        let attrChanges = {
                                            [ATTR_OBJ_ID]: row.original[ATTR_OBJ_ID],
                                            [ATTR_OBJ_TYPE]: row.original[ATTR_OBJ_TYPE],
                                            [tagId]: strYesNoValue(!isChecked)
                                        }
                                        prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([attrChanges])
                                    }
                                }
                            ]}
                            icon={ddIcon}
                            iconColor={isChecked && !showIfUrgent ? "main" : null}
                            text={false}
                            hideArrow
                            disabled={!project.getMayEditCheckBoxOrText(tagId)}
                            btnClass={"3rd"}
                            className={"flex-center ui-dropdown-right"}
                        />
                    return this.renderTableCellWithCopy(row, props.column, cellContent , false)
                },
                width: getColumnWidth(pid, tagId),
                Filter: CheckDropdown,
                filter: 'checkTags',
                sortType: 'tagSortTxt',
            });
        })
        return checkList
    }

    onTablePageChanged() {
        // cancel copy when change table page
    }

    filterOrSortChanged(what, newValues) {
        // Keep track of latest sort and filter columns to cancel "copy mode"
        if (this.state.markCopyFrom) {
            let prevSortAndFilter = JSON.stringify(this.latestSortAndFilter[what])
            let newSortAndFilter = JSON.stringify(newValues)
            if (prevSortAndFilter !== newSortAndFilter) {
                this.cancelTableCopyCells("Kopiointi keskeytetty")
            }
        }
        this.latestSortAndFilter[what] = newValues
    }

    markCopyStartOrEnd(row, column) {
        if (!row.original || !row.original.hasOwnProperty(ATTR_OBJ_ID)) {
            return
        }
        let rowIndex = getReadOnlyTableRows().findIndex(r => r.id === row.id)
        if (!this.state.markCopyFrom) {
            this.setState({
                markCopyFrom: {rowIndex: rowIndex, rowId: row.id, columnId: column.id, obsId: row.original[ATTR_OBJ_ID]},
                markCopyLength: 0,
            })
            prosAppNotif('Monistettava arvo merkitty. ' +
                'Valitse alueen viimeinen solu. ' +
                'Kohdesolu voi olla myös eri sivulla. ' +
                'Aikaisempi arvo ylikirjoitetaan. ',
            {
                type: 'notice',
                action: () => this.cancelTableCopyCells(),
                buttonText: 'Peru',
                icon: 'cancel'
            })
        } else {
            let dst = {rowIndex: rowIndex, rowId: row.id, columnId: column.id, obsId: row.original[ATTR_OBJ_ID]}
            if (dst.rowId === this.state.markCopyFrom.rowId) {
                this.cancelTableCopyCells('Kopiointi peruttu')
            }
            if (dst.columnId !== this.state.markCopyFrom.columnId) {
                this.cancelTableCopyCells('Kopiointi - lähde ja kohderivin sarake on eri')
                return
            }
            let copyCount = this.getMarkedCopyDstObsIds(this.state.markCopyFrom, dst).length
            if (copyCount > 0) {
                this.setState({markCopyTo: dst})
                prosAppNotifDismiss()      // To clear notification
                BasicModal('Vahvista kentän kopiointi',
    "Kopioidaanko arvo " + copyCount + " riville ?",
                {
                    action: () => this.confirmCopyTableFields(),
                    cancelCallback: ()=> this.cancelTableCopyCells()
                })
            }
        }
    }

    cancelTableCopyCells(why) {
        if (why) {
            prosAppNotifWarn(why)
        } else {
            prosAppNotifDismiss()
        }
        this.setState({
            markCopyFrom: undefined,
            markCopyTo: undefined,
        })
    }

    getMarkedCopyDstObsIds(src, dst) {
        const tableRows = getReadOnlyTableRows()
        // Note whan rows are sorted rowIndex may not be ascending/descending but in any order
        let srcRowIndex  = tableRows.findIndex(row => row.original[ATTR_OBJ_ID] === src.obsId)
        let lastRowIndex = tableRows.findIndex(row => row.original[ATTR_OBJ_ID] === dst.obsId)

        if (srcRowIndex === lastRowIndex) {
            this.cancelTableCopyCells("Kopiointi peruttu, sama rivi")
            return []
        }
        // Consolidate that src and dst row id's have not been changed
        if (srcRowIndex < 0 || lastRowIndex < 0 ||
            srcRowIndex >= tableRows.length || lastRowIndex >= tableRows.length) {
            this.cancelTableCopyCells("Kopiointi peruttu, sillä taulukon sisältö on muuttunut (1)")
            return []
        }
        let srcRow = tableRows[srcRowIndex]
        let lastRow = tableRows[lastRowIndex]
        // Consolidate that src and dst row id's have not been changed
        if (src.rowId !== srcRow.id ||
            dst.rowId !== lastRow.id) {
            this.cancelTableCopyCells("Kopiointi peruttu, sillä taulukon sisältö on muuttunut (2)")
            return []
        }

        let stepIndex = srcRowIndex < lastRowIndex ? 1 : -1    // Down positive, upwards negative
        let dstObsIds = []
        for (let i = srcRowIndex + stepIndex; i !== lastRowIndex + stepIndex; i += stepIndex) {
            dstObsIds.push(getReadOnlyTableRows()[i].original[ATTR_OBJ_ID])
        }
        return dstObsIds
    }

    async copyAttrforObs(obsToUpdate, srcObs, attr, progress, total) {
        // Copy selected column or mark as no value if missing
        let attrChanges = obsToUpdate.map(obs => {
            return {
                [ATTR_OBJ_ID]: obs[ATTR_OBJ_ID],
                [ATTR_OBJ_TYPE]: obs[ATTR_OBJ_TYPE],
                [attr]: srcObs.hasOwnProperty(attr) ? srcObs[attr] : STR_NO_VALUE
            }
        })
        await prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes(attrChanges, false)
        prosNotificationShow(this,
            ['Kopioidaan ' + progress + '/' + total],
            {
                action: () => this.cancelTableCopyCells(),
                text: 'Keskeytä kopiointi',
                icon: 'cancel'
            })
    }


    async confirmCopyTableFields() {
        prosPopupClose()
        let srcObs = prosConnect.getObjById(this.state.markCopyFrom.obsId)
        if (!srcObs) {
            this.cancelTableCopyCells("Kopiointi peruttu, tiedot muuttuneet")
            return
        }
        let dstObsIds = this.getMarkedCopyDstObsIds(this.state.markCopyFrom, this.state.markCopyTo)
        if (dstObsIds.length < 1) {
            return
        }

        let progress = 0
        let obsToUpdate = []

        // Items updated incrementally
        //      - avoid timeout if server would exceed 30 s
        //      - in addition user can see progress and able to break
        const MAX_UPDATE_PER_MSG = 4 // 100
        const MIN_UPDATE_PER_MSG = 2 // 10
        let sendItemsPerMsg = dstObsIds.length/5
        if (sendItemsPerMsg > MAX_UPDATE_PER_MSG) {
            sendItemsPerMsg = MAX_UPDATE_PER_MSG
        } else if (sendItemsPerMsg < MIN_UPDATE_PER_MSG) {
            sendItemsPerMsg = MIN_UPDATE_PER_MSG
        }

        let attr = this.state.markCopyFrom.columnId === 'ui_expires' ? ATTR_EXPIRATION : this.state.markCopyFrom.columnId
        while (progress < dstObsIds.length) {
            prosAppNotif("Kopioidaan " + progress + " / " + dstObsIds.length)
            let dstObs = prosConnect.getObjById(dstObsIds[progress])
            if (!dstObs) {
                this.cancelTableCopyCells("Kopiointi keskeytetty, sillä yksi kohderivi on poistettu?")
                return
            }
            obsToUpdate.push(dstObs)
            progress++
            if (progress % sendItemsPerMsg === 0) {
                await this.copyAttrforObs(obsToUpdate, srcObs, attr, progress, dstObsIds.length)
                obsToUpdate.length = 0
            }
        }
        if (obsToUpdate.length > 0) {
            progress++
            await this.copyAttrforObs(obsToUpdate, srcObs, attr, dstObsIds.length, dstObsIds.length)
        }
        prosAppNotif("Tallennettu " + dstObsIds.length)
        this.cancelTableCopyCells()
        await this.loadAndRefreshUi()
    }

    // Text columns
    getTextColumns(project) {
        let txtList = [];
        let pid = project.getPid()
        project.getTxtLabels().forEach((label, i) => {
            let tagId = project.getTxtTags()[i];     // "txt" + i,
            txtList.push({
                Header: label,
                id: tagId,
                accessor: rowObs => {
                    let value = prosConnect.getValidAttr(rowObs, tagId)
                    return value ? value : ''
                },
                Cell: (props) => {
                    const { row } = props;
                    let textFieldType = project.getTextFieldType(tagId)
                    let displayTxt
                    if (isMultiEnumSelectionType(textFieldType)) {
                        let txt = prosConnect.getValidAttr(row.original, tagId, "")
                        let values = txt.split(';')
                        if(this.state.showCommentsInTable && values.length > 1){
                            displayTxt = values.map(itm => {
                                return <React.Fragment key={"enum__list"+ itm}>{itm}</React.Fragment>
                            })
                        } else {
                            displayTxt = getTextFieldText(project, row.original, tagId)
                        }
                    } else {
                        displayTxt = getTextFieldText(project, row.original, tagId)
                    }
                    if (project.isTxtMandatory(tagId) && displayTxt === TEXT_FIELD_WHEN_MISSING) {
                        return this.renderTableCellWithCopy(row, props.column, TEXT_FIELD_WHEN_MISSING, true)
                    }
                    return this.renderTableCellWithCopy(row, props.column, displayTxt, null,
                        (textFieldType === prosConnect.TEXT_FIELD_TYPE_TXT ? "text" : null))
                },
                filter: 'text',
                sortType: 'tagSortTxt',
                width: getColumnWidth(pid, tagId),
            })
        })
        return txtList
    }

    selectItemAndGetData(report, closepopups) {
        resetPageNumber(prosConnect.getActiveProjectID())
            if(closepopups) this.closeAppPopups()
        this.itemSelected(report)
        this.refreshUi("selectItemAndGetData")
    }

    clearTextFilterText() {
        savedUiMode.filterText = ''
        this.setState({
            filterTextInput: '',
        })
    }

    doSelectAllReports() {
        let reports = prosConnect.getActiveProject().getReports(true)
        reports.forEach( report => {
            report.ui_isOpen = false
            this.selectReports(report)
        })
    }

    selectReports(item) {
        prosConnect.prosLog('Selected item ', item.obj_id, item.obj_type);
        if (!prosConnect.getActiveProject().isReportSelected(item.obj_id)) {
            prosConnect.isReportToSelect(item, 'ProjectReport:selecReports()')
        }
    }

    filterChosenObs() {
        let project = prosConnect.getActiveProject();
        if (project) {
            let chosenObsId = this.state.selectedObsId;
            if (chosenObsId.length) {
                let matchIdWithObs = project.objs.find( (itm) => itm[ATTR_OBJ_ID] === chosenObsId);
                if (matchIdWithObs) {
                    matchIdWithObs.ui_isOpen = true
                    this.setState( {
                        chosenObs: [matchIdWithObs],
                    });
                }
            }
        }
    }

    toggleDragState() {
        // Cancel operations when turning on or off drag-drop rearrange
        getCopyMoveManager().cancelOperations()
        prosAppNotifDismiss()
        const newDragState = !this.state.dragState
        this.setState( {
           dragState: newDragState
        })
        getCopyMoveManager().setRearrangeMode(newDragState)
        this.refreshUi("toggleDragState")
    }

    notifFromReport(text, warning, dismissByUser, showLoadingSpinner, notifButtonSettings) {
        prosNotificationShow(this, text, warning, dismissByUser, showLoadingSpinner, notifButtonSettings)
    }

    gotoPage(page, resumeSearchListMode, param) {
        savedUiMode.isSearchMode = resumeSearchListMode;
        this.props.gotoPage(page, param)
    }

    renderChosenObs() {
        return this.state.chosenObs.map(
            report => <RenderReport
                key={report.obj_id}
                report={report}
                itemSelected={this.itemSelected}
                refreshParentUi={this.refreshUi}
                notif={this.notifFromReport}
                gotoPage={this.gotoPage}
                isObsSidePanel={true}
                mainViewMode={this.props.reportViewMode}
                onSelectObs={(newObsId)=>{
                    this.setFocusToObs(newObsId)
                }}
            />)
    }

    saveObsAttr(attr, value, obs) {
        if (!this.state.cellEdit && !obs) return
        let saveObs = obs ||  this.state.cellEdit.obs
        let attrChanges = {
            [ATTR_OBJ_ID]: saveObs[ATTR_OBJ_ID],
            [ATTR_OBJ_TYPE]: saveObs[ATTR_OBJ_TYPE],
            [attr]: value
        }
        prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([attrChanges])
        this.setState({cellEdit: undefined})
    }

    openCellEditTextModal(tag) {
        let project = prosConnect.getActiveProject();
        if (!project.getMayEditCheckBoxOrText(tag)) {
            return null
        }
        let obs = this.state.cellEdit.obs
        let tagIndex = project.getTxtTags().indexOf(tag)
        if (tagIndex < 0) {
            prosLogErr("Index error for TXT TAG", tag, project.getChTags());
            return null
        }
        let modalContent = null
        let title = 'Muokkaa'
        let txt = obs[tag]
        let isMandatoryAndMissing = project.isTxtMandatory(tag) && isValueEmpty(txt)
        let textFieldType = project.getTextFieldType(tag)
        if (isEnumSelectionType(textFieldType)) {
            title = 'Muokkaa' // ProsEnumMenu will set dialog sub title
            modalContent = <ProsEnumMenu
                label={project.getTxtLabel(this.props.tagIndex)}
                txt={txt}
                textFieldType={textFieldType}
                onChange={(val)=> {
                    txt = val
                }}
                isMandatoryAndMissing={isMandatoryAndMissing}
            />
        }else{
            modalContent = <ProsTxtTagMenu
                tag={tag}
                label={project.getTxtLabels()[tagIndex]}
                isMenuShown={true}
                txt={txt}
                textFieldType={textFieldType}
                onChange={(val)=> {
                    txt = val
                }}
                isMandatoryAndMissing={isMandatoryAndMissing}
            />
        }

        BasicModal(title, modalContent, {
            action: ()=> {
                this.saveObsAttr(tag, txt)
                txt = null
            },
            //keepWidth: true //commenting out for release
        })
    }

    openCellEditMultiSelectModal(obs, tag) {
        let project = prosConnect.getActiveProject()
        let tagIndex = project.getRbTags().indexOf(tag)
        if (tagIndex < 0) {
            prosLogErr("RG tag OOR", tag, project.getRbTagTitles())
            return null
        }
        let title = project.getRbTagTitles()[tagIndex]     // example 'Tila'
        let labels = project.getRbTagLabels(tagIndex)      // example 'Kirjattu', 'Korjattu', Tarkastettu';
        if (!title || !labels || labels.length < 2) {
            return null
        }
        let tagVal = -1
        if (obs.hasOwnProperty(tag) && obs[tag] !== STR_NO_VALUE) {
            tagVal = parseInt(obs[tag]);
            if (project.getRbTagTitles().length < tagIndex) {
                return null
            }
        }
        if (labels.length < tagVal) {
            tagVal = -1;
        }
        let tagOptionIndeces = project.getMayEditRbTagIndeces(obs, tagIndex);
        if (tagOptionIndeces.length <= 0) {
            return null
        }
        let modalContent = <ProsRbTagMenu
            key={tag}
            title={title}
            tagOptionIndeces={tagOptionIndeces}
            selectedIndex={tagVal}
            onSelect={selectedIndex => {
                this.saveObsAttr(tag, selectedIndex.toString())
                this.setState({cellEdit: undefined})
                BasicModalDismiss()
            }}
            tagInd={tagIndex}
            project={project}
            isMandatoryAndMissing={project.isRbTagMandatory(tag) && tagVal < 0}
        />

        BasicModal(title, modalContent, {
                action: ()=> {
                    this.setState({cellEdit: undefined})
                    BasicModalDismiss()
                },
                btnText: 'Sulje',
                hideDismissButton: true
            }
        )
    }

    setupCellEditMenu(selectedRow, selectedCell) {
        if (!selectedRow.original) {
            return
        }
        if(selectedCell.column.id.indexOf(TAG_RB_PREFIX) === 0 ||
            selectedCell.column.id.indexOf(TAG_TXT_PREFIX) === 0){
            this.setState({
                    cellEdit: {
                        obs: selectedRow.original,
                        columnId: selectedCell.column.id
                    }
                }, ()=>{
                if(selectedCell.column.id.indexOf(TAG_RB_PREFIX) === 0){
                    this.openCellEditMultiSelectModal(selectedRow.original, selectedCell.column.id)
                }else this.openCellEditTextModal(selectedCell.column.id)
            })
            return true
        }
        return false
    }

    closeSidePanel() {
        this.setState({
            showSidepanel: false,
            selectedObsId: '',
            selectedRow: null
        })
    }

    showSidepanelFromRowId = (selectedRow, selectedCell) => {
        getCopyMoveManager().cancelOperations()
        if (!selectedRow) {
            return
        }
        if (this.setupCellEditMenu(selectedRow, selectedCell)) {
            return
        }
        if (selectedRow.original.obj_id === this.state.selectedObsId && this.state.showSidepanel) {
            this.closeSidePanel()
        } else {
            this.setState({
                showSidepanel: true,
                selectedRow: selectedRow.original.obj_id,
                selectedObsId: selectedRow.original.obj_id,
            }, function () {
                this.filterChosenObs()
            })
        }
    }

    /**
     * Prepare table to show dashboard or notification filter
     */
    selectReportsForLink(meterSettings, link) {
        let activeProject = prosConnect.getActiveProject()
        if (!activeProject) {
            return
        }
        let reportsSelectedByMeter = meterSettings &&
            meterSettings[ATTR_OBJ_TYPE] === "meter_gantt" &&
            meterSettings.reportIds &&
            meterSettings.reportIds.length
        this.setState({disableShowingReportSelection: reportsSelectedByMeter})
        if (reportsSelectedByMeter) {
            activeProject.selectReportsById(meterSettings.reportIds)
        } else if (link) {
            // Continue using report selected by a link
        } else {
            // Meter does not have a filter yet - show table with default settings
            this.doSelectAllReports()
        }
    }

    setupShowingMeterOrNotifRuleDataInTable({linkUuid, projectId, meterSettings, link}) {
        if (!link) {
            if (meterSettings) {
                // Set table default filtering based on meter type
                setTableFilter(projectId, getTableFilterForMeter(meterSettings))
                savedUiMode.isSearchMode = false
            } else {
                // Notification rule - when link is not saved use as default no filtering
                setTableFilter(projectId, [])
            }
        }
        if (meterSettings) {
            // Set table sorting based on meter type - instead of using saved sorting rules
            setTableSort(projectId, getTableSortingForMeter(meterSettings))
        }
        // Reports may be selected by meter setting or selected by user - when no link select all
        this.selectReportsForLink(meterSettings, link)

        // Open all table filters by default
        this.setState({
            showColumnFilters: true,
        })

        // 2022.10.28 - force report list mode until server supports cascaded #2.319
        this.setState({
            showingSearchList: false
        })
        savedUiMode.isSearchMode = false

        //Hide elements when editing filters for dashboard or notification rule
        this.toggleElementsWhenEditingCharts() // TODO Sampo - instead of "toggle" remove redux here ?
    }

    // TODO Sampo - instead of "toggle" add parameter "show" and based on that remove or add "redux" ?i
    // TODO "Toggle" is more vulnerable that "set" - risk to get "out of synch"
    toggleElementsWhenEditingCharts(){
        if(document.documentElement.classList.contains('redux')) document.documentElement.classList.remove('redux')
        else document.documentElement.classList.add('redux')
    }

    async saveFilterToMeterOrNotifRule() {
        let linkId = await awaitMakeProjectLink(true, this.props.editLinkForTable.linkUuid)
        if (!linkId) {
            prosLogErr("Failed to create or update link")
            prosAppNotifWarnConfirm("Suodatusten tallennus epäonnistui")
            return
        }
        if (this.props.editLinkForTable.meterSettings) {
            await savePdashMeter(this.props.editLinkForTable.projectId, this.props.editLinkForTable.meterSettings)
            prosConnect.prosLog("Meter data filter updated into link:", linkId)
            prosAppNotif("Kuvaajan suodatukset tallennettu")
        } else {
            prosConnect.prosLog("Notification rule conditions filter updated into link:", linkId)
            prosAppNotif("Ilmoitussäännön suodatukset tallennettu")
        }
    }

    renderTableView() {
        if (!this.state.isDataPreparedForTable) {
            return <LoadingAnimation size="lg"/>
        }
        let activeProjectId = prosConnect.getActiveProjectID()
        return <>
            <section className={"table-view table-view-table"}>
                <ProjectReportTable
                    activeProjectId={activeProjectId}
                    selectedRow={this.showSidepanelFromRowId}
                    selectedRowState={this.state.selectedRow}
                    columnOrderFromParent={this.state.columnOrderForTable}
                    hiddenColumnsFromParent={this.state.hiddenColumnsForTable}
                    showComments={this.state.showCommentsInTable}
                    showFulltextInTable={this.state.showFulltextInTable}
                    data={this.state.dataForTable}
                    columns={this.state.columnsForTable}
                    markCopyFromRowIndex={this.state.markCopyFrom ? this.state.markCopyFrom.rowIndex : -1}
                    markCopyToRowIndex={this.state.markCopyTo ? this.state.markCopyTo.rowIndex : -1}
                    markCopyColumnId={this.state.markCopyFrom ? this.state.markCopyFrom.columnId : undefined}
                    onPageChanged={() => this.onTablePageChanged()}
                    filterOrSortChanged={(what, newValues) => this.filterOrSortChanged(what, newValues)}
                    renderToolbar={()=> this.renderReportToolbar()}
                    showColumnFilters={this.state.showColumnFilters}
                    useAutoColor={this.state.useTableMultiSelectAutoColor}
                />
                <p className={"tip text-center"}>Pidä shift-näppäintä pohjassa lajitellaksesi useamman sarakkeen perusteella samanaikaisesti.</p>
                <SidePanel
                    show={this.state.showSidepanel}
                    closeCallback={()=> this.closeSidePanel()}
                >
                    {this.renderChosenObs()}
                </SidePanel>
            </section>
        </>
    }

    renderUiList() {
        if (this.isViewModeChanging()) {
            return null
        }
        if (this.uiList.length < 1 && this.props.reportViewMode !== VIEW_MODE_DASHBOARD) {
            let excuseNoItems = ""
            if (this.state.filterTextInput !== '' && !savedUiMode.isSearchMode) {
                excuseNoItems = "Tekstihaulla ei tuloksia"
            } else {
                let project = prosConnect.getActiveProject()
                if (savedUiMode.isSearchMode) {
                    excuseNoItems = project.getObjectTypeCount(OBJ_TYPE_LST_SEARCH) +
                                    project.getObjectTypeCount(OBJ_TYPE_LST_SEARCH_R) > 0 ?
                        "": // "Valitse hakuraportti":
                        "Osaprojektissa ei ole hakuraportteja"
                } else {
                    excuseNoItems = project.getObjectTypeCount(OBJ_TYPE_LST) > 0 ?
                        "" : "Aloita käyttö lisäämällä raportti"
                }
            }
            return <div className={"mini-page text-center"}>
                <header>
                    <h3>{excuseNoItems !== '' ? excuseNoItems : "Ei näytettäviä tietoja"}</h3>
                </header>
                <section>
                    <figure className={"margin-bottom"}>
                        <img src={"/images/illustrations/box-empty.svg"} alt={"Empty box"}/>
                    </figure>
                    {this.renderSelectReportsButton(true)}
                </section>
            </div>
        } else {
            if (this.props.reportViewMode === VIEW_MODE_TABLE) {
                require('./assets/scss/views/Table.scss')
                return this.renderTableView()
            }  else if (this.props.reportViewMode === VIEW_MODE_CALENDAR || this.props.reportViewMode === VIEW_MODE_KANBAN) {
                return <ScheduleMatrix
                    uiList = {this.uiList}
                    uiListRefreshed = {this.state.uiListRefreshed}
                    showingSearchList = {this.state.showingSearchList}
                    projectId={prosConnect.getActiveProjectID()}
                    renderToolbar={()=> this.renderReportToolbar()}
                    selectedObsId={this.state.selectedObsId}
                    onSelectObs={(newObsId)=>{
                        this.setFocusToObs(newObsId)
                    }}
                    viewMode={this.props.reportViewMode}
                />
            } else if (this.props.reportViewMode === VIEW_MODE_LIST){
                require("./assets/scss/views/List.scss")
                return <div className={"report-list"
                        + (this.state.dragState ? " reorder-active" : "")
                    }>
                    {this.uiList.map(
                        (report) => <RenderReport
                            key={report.obj_id + '__rr'}
                            report={report}
                            itemSelected={this.itemSelected}
                            //ind={report}
                            refreshParentUi={this.refreshUi}
                            notif={this.notifFromReport}
                            gotoPage={this.gotoPage}
                            mainViewMode={this.props.reportViewMode}
                            listReversed={this.state.listReversed}
                        />
                    )}
                </div>
            } else {
                return <Dashboard
                    projectId={prosConnect.getActiveProjectID()}
                    editTableLinkSettings = {this.props.editTableLinkSettings}
                />
            }
        }
    }

    openPopupColumnSettings() {
        prosPopupOpenDynamic(this,
            'Taulukkoasetukset',
            () => this.columnSettingsHtml(),
            () => this.hideSettings()
        )
    }

    columnSettingsHtml() {
        return <>
            <section>
                <h3>Näkymä</h3>
                <ToggleSwitch
                    label={"Käytä automaattisia värejä monivalinnoissa"}
                    checked={this.state.useTableMultiSelectAutoColor}
                    onChange={()=> this.toggleShowAutoColor()}
                />
                <Spacer size={"lg"}/>
                {this.renderColumnOptions()}
            </section>
            <footer className={"popup-footer"}>
                <div className={"btn-set"}>
                    <ConfirmButton
                        label={"Valmis"}
                        action={()=> this.saveColumnSettings()}
                    />
                </div>
            </footer>
        </>
    }

    renderColumnOptions() {
        let sortedColumns = []
        let columns = this.state.columnsForTable
        this.state.columnIdOrder.forEach( key => {
            for (let column of columns) {
                let columnId = column.id ? column.id : column.accessor
                if (columnId === key) {
                    sortedColumns.push(column)
                    return
                }
            }
        })
        return <>
            <header className={"element-set valign-center margin-bottom"}>
                <h3 className={"flex-grow margin-0"}>Sarakeasetukset</h3>
                <BasicButton
                    btnClass={"2nd"}
                    label={"Palauta oletus sarakeleveydet"}
                    action={() => this.resetToDefaultWidths()}
                    size={"md"}
                />
            </header>
            {sortedColumns.map((column, i) => {
                let columnId = column.id ? column.id : column.accessor
                if (columnId === 'ui_obj_id') {
                    return null
                }
                return <div key={i}
                        draggable={"true"}
                        onDragStart={() => this.setDraggedColumnId(columnId)}
                        onDragOver={(evt) => {
                            evt.preventDefault()
                            //if(evt.target.draggable) evt.target.classList.add('drop-indicator')
                        }}
                        onDrop={(evt) =>{
                            //evt.target.classList.remove('drop-indicator')
                            this.moveDraggedToPosition(columnId, evt)
                        }}
                        onDragEnd={(evt) => {
                            evt.preventDefault()
                            //evt.target.classList.remove('drop-indicator')
                            this.setDraggedColumnId('')
                        }}
                        className={"column-setting"
                            + (this.state.slideUpId === columnId ? " slide-up" : this.state.slideDownId === columnId
                                ? " slide-down" : "")}
                    >
                    <div draggable={"false"}>
                        <ToggleSwitch
                            checked={!this.state.hiddenColumnIds.includes(columnId)}
                            onChange={() => this.changeColumnVisibility(columnId)}
                        />
                        <p className={"flex-grow margin-0"}>{column.Header}</p>
                        <div className={"btn-set"}>
                            <BasicButton
                                action={() => {this.decreaseColumnOrder(columnId)}}
                                disabled={this.state.columnIdOrder.indexOf(columnId) <= 0}
                                title={"Siirrä ylöspäin"}
                                size={"md"}
                                icon={"arrow-up"}
                                iconSize={"sm"}
                            />
                            <BasicButton
                                action={() => {this.increaseColumnOrder(columnId)}}
                                disabled={this.state.columnIdOrder.indexOf(columnId)+1 >= this.state.columnIdOrder.length}
                                title={"Siirrä alaspäin"}
                                size={"md"}
                                icon={"arrow-down"}
                                iconSize={"sm"}
                            />
                        </div>
                    </div>
                </div>
            })}
        </>
    }

    setDraggedColumnId(columnId) {
        this.setState({
            draggedColumnId: columnId,
            slideDownId: "",
            slideUpId: "",
        })
    }

    moveDraggedToPosition(targetId, e) {
        e.preventDefault();
        if (targetId === this.state.draggedColumnId) {
            return
        }
        const indexOfDragged = this.state.columnIdOrder.indexOf(this.state.draggedColumnId)
        const indexOfTarget = this.state.columnIdOrder.indexOf(targetId)
        const newColumnOrder = this.state.columnIdOrder
        if (indexOfDragged < indexOfTarget) {
            for (let i = indexOfDragged; i < indexOfTarget; i++) {
                [newColumnOrder[i], newColumnOrder[i+1]] = [newColumnOrder[i+1], newColumnOrder[i]];
            }
        }
        if (indexOfTarget < indexOfDragged) {
            for (let i = indexOfDragged; i > indexOfTarget; i--) {
                [newColumnOrder[i], newColumnOrder[i-1]] = [newColumnOrder[i-1], newColumnOrder[i]];
            }
        }
        this.setDraggedColumnId("")
    }

    decreaseColumnOrder(columnId) {
        const indexOfColumnId = this.state.columnIdOrder.indexOf(columnId);
        if (indexOfColumnId <= 0) {
            // Tolerate missing column
            return
        }
        const newColumnOrder = this.state.columnIdOrder;
        [newColumnOrder[indexOfColumnId], newColumnOrder[indexOfColumnId-1]] = [newColumnOrder[indexOfColumnId-1], newColumnOrder[indexOfColumnId]];
        this.setState({
            slideUpId: columnId,
            slideDownId: "",
            columnIdOrder: newColumnOrder,
        })
    }

    increaseColumnOrder(columnId) {
        const indexOfColumnId = this.state.columnIdOrder.indexOf(columnId);
        if (indexOfColumnId < 0 || indexOfColumnId+1 >= this.state.columnIdOrder.length) {
            // Tolerate missing column, no action when last column
            return
        }
        const newColumnOrder = this.state.columnIdOrder;
        [newColumnOrder[indexOfColumnId], newColumnOrder[indexOfColumnId+1]] = [newColumnOrder[indexOfColumnId+1], newColumnOrder[indexOfColumnId]];
        this.setState({
            slideUpId: "",
            slideDownId: columnId,
            columnIdOrder: newColumnOrder,
        })
    }

    changeColumnVisibility(columnId) {
        let newHiddenColumnIds = this.state.hiddenColumnIds;
        if (!this.state.hiddenColumnIds.includes(columnId)) {
            newHiddenColumnIds.push(columnId);
        } else {
            newHiddenColumnIds.splice(newHiddenColumnIds.indexOf(columnId), 1);
        }
        this.setState({
            hiddenColumnIds: newHiddenColumnIds,
        })
    }

    hideSettings() {
        let pid = prosConnect.getActiveProjectID()
        let newColumnOrder = getSavedTableSetting(localStorage, pid, SAVED_COL_ORDER, this.state.defaultColumnIdOrder)
        this.setState({
            slideDownId: "",
            slideUpId: "",
            hiddenColumnIds: getSavedTableSetting(localStorage, pid, SAVED_HIDDEN_COLS, TABLE_DEFAULT_HIDDEN_COLS),
        });
        if (newColumnOrder.length > 0) {
            this.setState({
                columnIdOrder: newColumnOrder,
                columnOrderForTable: newColumnOrder,
            });
        }
        prosPopupClose()
        setHelpContext('closePopup')
        this.props.refreshProjectView()
    }

    resetToDefaultWidths() {
        prosPopupClose()
        this.setState({
            isDataPreparedForTable: false,
            slideDownId: "",
            slideUpId: "",
        })
        clearToDefaultTableSettings()
        this.props.refreshProjectView()
        this.setState({
            columnOrderForTable: this.state.defaultColumnIdOrder,
            hiddenColumnsForTable: TABLE_DEFAULT_HIDDEN_COLS,
            })
        this.hideSettings()
        this.props.refreshProjectView()
    }

    saveColumnSettings() {
        let pid = prosConnect.getActiveProjectID()
        localStorage.setItem(SAVED_HIDDEN_COLS + pid, JSON.stringify(this.state.hiddenColumnIds))
        localStorage.setItem(SAVED_COL_ORDER + pid, JSON.stringify(this.state.columnIdOrder))
        this.setState({
            columnOrderForTable: this.state.columnIdOrder,
            hiddenColumnsForTable: this.state.hiddenColumnIds,
        }, () => {
            this.hideSettings()
        })
    }

    setActiveObsFromLocationPictureList(obs) {
        if (obs.obj_id === this.state.selectedObsId && this.state.showSidepanel) {
            this.closeSidePanel();
        } else {
            this.setState({
                showSidepanel: true,
                selectedObsId: obs.obj_id}, function() {
                this.filterChosenObs();
            });
        }
    }

    toggleVisibilityOfLocationPictureList() {
        this.setState({locationPictureListVisibility: !this.state.locationPictureListVisibility})
    }

    renderLocationPictureList() {
        if (this.props.reportViewMode === VIEW_MODE_TABLE && this.uiList && this.uiList.length) {
            return <LocationPictureList
                hash={this.state.locationPictureHash}
                selectedObsId={this.state.selectedObsId}
                setActiveObsFromLocationPictureList={this.setActiveObsFromLocationPictureList}
                locationPictureListVisibility={this.state.locationPictureListVisibility}
                toggleVisibilityOfLocationPictureList={this.toggleVisibilityOfLocationPictureList}
              />
        }
    }

    renderProjectLoadProgress() {
        if (this.props.reportViewMode === VIEW_MODE_DASHBOARD) {
            return null
        }
        let projectLoadPercentage = 100 - projectLoader.getProjectLoadStatusPercentage()
        return projectLoadPercentage < 100 ?
            <div className={"project-loading-bar"}>
                <span className={"loading-progress"}
                      style={{width:projectLoadPercentage+"%"}}/>
            </div>
            : null
    }

    restoreNormalTableMode() {
        this.setState({isDataPreparedForTable: false})
        this.toggleElementsWhenEditingCharts() // TODO Sampo - instead of "toggle" enable here ?
        this.props.continueFromTableFilter()
    }

    renderReturnOrSaveSettings() {
        if (this.props.editLinkForTable) {
            let editFiltersTitle = this.props.editLinkForTable.meterSettings
                ? "Kuvaajan asetukset"
                : "Ilmoitussäännön asetukset"
            return <div className={"element-set flex-grow"}>
                    <h2 className={"flex-grow"}>{editFiltersTitle}</h2>
                    <div className={"btn-set"}>
                        <CancelButton
                            action={()=> this.restoreNormalTableMode()}
                            tooltip={["Peru ja palaa takaisin"]}
                        />
                        <ConfirmButton
                            action={async () => {
                                await this.saveFilterToMeterOrNotifRule()
                                this.restoreNormalTableMode()
                            }}
                            tooltip={["Tallenna ja palaa takaisin"]}
                        />
                    </div>
            </div>
        }
    }

    isViewModeChanging() {
        return savedUiMode.viewMode !== this.props.reportViewMode
    }

    reportViewModeChanged() {
        let mode = this.props.reportViewMode
        this.clearTextFilterText()
        this.closeAppPopups()
        if (mode !== VIEW_MODE_LIST && this.state.filterTextInput !== "") {
            this.clearTextFilter()
        }
        if (mode !== VIEW_MODE_LIST){
            this.setState( {
                dragState: false
            })
        }
        savedUiMode.viewMode = mode
        if ( ! [VIEW_MODE_CALENDAR, VIEW_MODE_KANBAN].includes(mode)) {
            // for list and table mode get view settings by main view
            // for other sub-view ( matrix only so far ) should register their own ui settings provider
            prosConnect.registerToRetrieveViewSettings(this.props.reportViewMode, (projectId)=>this.retrieveViewSettings(projectId))
        }
        if (mode === VIEW_MODE_TABLE) {
            this.setDataForTable(prosConnect.getActiveProject())
            // By default show report selection
            this.setState({disableShowingReportSelection: false})
            // Clear table settings to force making table columns
            clearColumnWidthCache()
            let activeProject = prosConnect.getActiveProject()
            this.setColumnsForTable(activeProject)
            this.setState({isDataPreparedForTable: true})
            if (this.props.editLinkForTable) {
                this.setupShowingMeterOrNotifRuleDataInTable(this.props.editLinkForTable)
            } else {
                this.setState({
                    showColumnFilters: false,
                })
            }
        } else {
            this.setState({isDataPreparedForTable: false})
        }
        let pollForChanges = mode !== VIEW_MODE_DASHBOARD
        projectLoader.subscribeRefreshUiWhenDataChanged(pollForChanges, VIEW_ID_FOR_SUBSCRIBE,
                (who, change) => this.onProjectDataChanged(who, change));
        this.loadDataForUi("reportViewModeChanged")
        setHelpContext(mode)
    }

    toggleTableSetting(settings) {
        savedUiMode[settings] = !savedUiMode[settings]
        this.setState( {
          [settings]: savedUiMode[settings],
        })
    }

    toggleShowAutoColor() {
        savedUiMode.useTableMultiSelectAutoColor = !savedUiMode.useTableMultiSelectAutoColor
        this.setState({
            useTableMultiSelectAutoColor: savedUiMode.useTableMultiSelectAutoColor
        })
    }

    renderWrapDropdown() {
        const menuItems = [
            {
                icon: "comment-text",
                text: 'Näytä kommentit',
                action: ()=> {
                    this.toggleTableSetting('showCommentsInTable')
                },
                selected: this.state.showCommentsInTable
            },
            {
                icon: "read-more",
                text: 'Näytä koko teksti',
                action: ()=> {
                    this.toggleTableSetting('showFulltextInTable')
                },
                selected: this.state.showFulltextInTable
            }
        ]
        return <DropdownMenu
            values={menuItems}
            icon={"read-more"}
            btnClass={"3rd"}
            text={false}
            active={this.state.showCommentsInTable || this.state.showFulltextInTable}
        />
    }

    applyTableFilterAndSort(option) {
        let pid = prosConnect.getActiveProjectID()
        prosLog("applyTableFilterAndSort option:", option)
        // Ref option parameter below in QUICK_SORT_SEARCH_OPTIONS
        setTableFilter(pid, option.filter)
        setTableSort(pid, option.sort)
        this.props.refreshProjectView()
        prosAppNotif("Taulukossa: " + option.text)
    }

    renderSortingMenu() {
        // Pickup from drop down list selected quick setting for table common sorting and filtering
        const QUICK_SORT_SEARCH_OPTIONS = [
            {
                value: 1,
                text: "Viimeksi muokattu",
                filter : [],
                sort: [{"id": UPDATED_TIME_TITLE, "desc": true}],
            },
            {
                value: 2,
                text: "Olen muokannut viimeksi",
                filter : [{"id": UPDATED_BY_TITLE, "value": prosConnect.getUserEmail(true)}],
                sort: [{"id": UPDATED_TIME_TITLE, "desc": true}],
            },
            {
                value: 3,
                text: "Kuluvalla viikolla erääntyvät",
                filter : [{"id": "ui_timeToDate", "value": [FLT_RANGE_WEEK, "", "1"]}],
                sort: [{"id": "ui_expires", "desc": false}],
            },
            {
                value: 4,
                text: "Tänään erääntyvät",
                filter : [{"id": "ui_timeToDate", "value": [FLT_RANGE_DAY, "", "1"]}],
                sort: [{"id": "ui_expires", "desc": false}],
            },
            {
                value: 5,
                text: "Pakollisia tietoja puuttuu",
                filter : [{"id": "ui_mandatoryMissing", "value": ['1', '']}],
                sort: [{"id": "ui_mandatoryMissing", "desc": true}],
            }
        ]
        return <DropdownMenu
            values={QUICK_SORT_SEARCH_OPTIONS}
            onSelect={value => this.applyTableFilterAndSort(QUICK_SORT_SEARCH_OPTIONS.find(o => value === o.value) )}
            btnClass={"3rd"}
            icon={"sort-list-up"}
            tooltip={["Pikavalinnat"]}
            text={false}
        />
    }

    renderDragToggle() {
        if (!prosConnect.hasPermissionToReorder() || this.state.showingSearchList) return null
        const isSearchActive = this.state.filterTextInput !== ''
        return <BasicButton
            icon={"reorder"}
            selected={this.state.dragState}
            disabled={isSearchActive}
            tooltip={[isSearchActive ? "Estetty, koska tekstihaku on aktiivinen" : "Uudelleenjärjestele tietoja", "tooltip-bottom" + (this.state.dragState ? " tooltip-active tooltip-notice" : "")]}
            action={()=>{
                this.toggleDragState()
            }}
        />
    }

    renderSortAllToggle(){
        if (this.state.showingSearchList) return null
        return <BasicButton
            icon={"sort-list-" + (this.state.listReversed ? "up" : "down")}
            selected={this.state.listReversed}
            tooltip={["Näytä kirjaukset " + (this.state.listReversed ? "uusin" : "vanhin") +  " ensin", "tooltip-bottom"]}
            action={()=>{
                this.setState({listReversed: !this.state.listReversed})
            }}
        />
    }

    renderShowColumnFilters() {
        let pid = prosConnect.getActiveProjectID()
        let dropDownItems = []
        dropDownItems.push({
            text: (this.state.showColumnFilters ? 'Piilota' : 'Näytä') + ' kaikki suodattimet',
            action: ()=> {
                this.setState({showColumnFilters: !this.state.showColumnFilters})
            },
            icon: (this.state.showColumnFilters ? 'close-all' : 'open-all')
        })
        let filters = getTableFilter(pid)
        // prosConnect.prosLogX("Fetched table filters for", pid, filters)
        if (filters.length) {
            dropDownItems.push({
                text: 'Tyhjennä suodattimet',
                action: ()=> {
                    setTableFilter(pid, [])
                    this.props.refreshProjectView()
                },
                icon: 'times'
            })
        }
        let sorts = getTableSort(pid)
        if (sorts.length) {
            dropDownItems.push({
                text: 'Tyhjennä lajittelut',
                action: ()=> {
                    setTableSort(pid, [])
                    this.props.refreshProjectView()
                },
                icon: 'times'
            })
        }
        if(dropDownItems.length > 2){
            dropDownItems.push({
                text: 'Tyhjennä suodattimet ja lajittelut',
                action: () => {
                    setTableFilter(pid, [])
                    setTableSort(pid, [])
                    this.props.refreshProjectView()
                },
                icon: 'cancel'
            })
        }
        let filterAndSortCount = filters.length + sorts.length
        return <DropdownMenu
            values={dropDownItems}
            text={false}
            icon={filterAndSortCount ? "funnel_color-main" : "funnel"}
            tag={filterAndSortCount}
            btnClass={"3rd"}
            tooltip={["Suodattimet"]}
        />
    }

    renderColumnSettingsToggle() {
        return <BasicButton
            icon={"sliders"}
            tooltip={["Avaa taulukkoasetukset", "tooltip-bottom"]}
            action={()=>{
                this.openPopupColumnSettings()
                setHelpContext('tableColumnEditor')
            }}
            btnType={"prompt"}
        />
    }

    renderShareMenu() {
        let activeProject = prosConnect.getActiveProject()
        const noReportsSelected = activeProject.getSelectedReportIds(this.state.showingSearchList).length < 1
        return <DropdownMenu
            btnClass={"3rd"}
            icon={"share"}
            values={this.getShareOptions()}
            className={"ui-dropdown-align-right"}
            openDropdownCallback={()=>{
                setHelpContext('share')
            }}
            closeDropdownCallback={()=>{
                setHelpContext('closePopup')
            }}
            text={false}
            disabled={noReportsSelected}
        />
    }

    openGiveNameToBookmark =()=> {
        BasicModal('Tallenna kirjanmerkiksi', <SaveBookMarkDialog
                viewMode={savedUiMode.viewMode}
                closePopup={BasicModalDismiss}
                notifyParent={(notifText, warning, dismissByUser) =>
                    prosNotificationShow(this, notifText, warning, dismissByUser)}
            />,
    {
                hideDismissButton: true
        })
    }

    // callback for prosConnect to get view settings - matrix view will override
    retrieveViewSettings(projectId) {
        let uiSettings= this.props.reportViewMode === VIEW_MODE_TABLE ?
            restoreTableSettings(projectId, 'retrieveViewSettings', true):
            {filterText: this.state.filterTextInput}
        uiSettings.viewMode = this.props.reportViewMode
        uiSettings.showCommentsInTable = this.state.showCommentsInTable
        uiSettings.showFulltextInTable = this.state.showFulltextInTable
        uiSettings.useTableMultiSelectAutoColor = this.state.useTableMultiSelectAutoColor
        uiSettings.isSearchMode = savedUiMode.isSearchMode
        return uiSettings
    }

    // Get label or title for sending
    getSendPdfReportsTitle(reportViewMode) {
        let numOfReports = prosConnect.getActiveProject()
            .getSelectedReportIds(this.state.showingSearchList)
            .length
        if (reportViewMode === VIEW_MODE_LIST && this.props.reportViewMode === VIEW_MODE_TABLE) {
            return "Lähetä PDF-lista"
        } else if (reportViewMode === VIEW_MODE_LIST && numOfReports > 1) {
            return "Lähetä PDF-lista raporteista (" + numOfReports + ")"
        } else if (reportViewMode === VIEW_MODE_LIST) {
            return "Lähetä PDF-lista raportti"
        } else if(reportViewMode === VIEW_MODE_CALENDAR) {
            return "Lähetä PDF-kalenteri"
        } else {
            return "Lähetä PDF-taulukko"
        }
    }

    prosPopupOpenPromptPdfOptions(ui, reportViewMode, setOptionsCallback, closeCallback) {
        const isTableOrCalendarViewMode = reportViewMode === VIEW_MODE_TABLE || reportViewMode === VIEW_MODE_CALENDAR;
        const title = this.getSendPdfReportsTitle(reportViewMode)
        //Both comments and pics based on comments selection in table view
        const defaultShowCommentsAndPictures = isTableOrCalendarViewMode
            ? this.state.showCommentsInTable
            : true
        BasicModal(title,
            <PdfReportOptions
                title={title}
                closeCallback={BasicModalDismiss}
                setOptionsCallback={setOptionsCallback}
                showingSearchList={this.state.showingSearchList}
                defaultShowComments={defaultShowCommentsAndPictures}
                defaultShowPictures={defaultShowCommentsAndPictures}
                defaultPdfCoverPageTemplateName={"Pohjan nimi"}
            />,{
            hideDismissButton: true,
            className: "flexible"
        })
    }

    async shareSendPdf(reportViewMode, prodectViewMode = reportViewMode) {
        this.hideSharePopup()
        // Prompt user for title of pdf-report
        // Request for server to generate and send PDF reports
        const sendPdfReportRequest = async (pdfOptions) => {
            const text = reportViewMode === VIEW_MODE_CALENDAR
                ? "kalenteri"
                : reportViewMode === VIEW_MODE_TABLE
                    ? "taulukko"
                    : "lista";
            if (sendPdfRequest(this.state.showingSearchList, reportViewMode, pdfOptions, prodectViewMode)) {
                prosAppNotifConfirm(`PDF-${text} saapuu sähköpostiisi hetken kuluttua`)
            } else {
                prosAppNotif("Valitse raportteja tai haku")
            }
        }
        this.prosPopupOpenPromptPdfOptions(this, reportViewMode,
            (pdfOptions) => {
                prosPopupClose();
                sendPdfReportRequest(pdfOptions);
            }
        )
    }

    async testTableFilterFromServer() {
        const obsFromServer = await awaitTableFilteredObs()
        this.hideSharePopup()
        if (!obsFromServer) {
            return
        }
        const tableRows = getReadOnlyTableRows().map(row => row.original)
        // validate count
        let compareOk = true
        if (tableRows.length !== obsFromServer.length) {
            console.log("ERR - count mismatch - local:", tableRows.length, "server:", obsFromServer.length)
            compareOk = false
        }
        // validate each from local found from server
        tableRows.forEach(obs => {
            if (!obsFromServer.find(serverObs => serverObs.obj_id === obs.obj_id)) {
                console.log("ERR - not found from server:", obs.obj_id, obs.obs_id, obs.text)
                compareOk = false
            }
        })
        // validate each from server is local
        obsFromServer.forEach(serverObs => {
            if (!tableRows.find(obs => serverObs.obj_id === obs.obj_id)) {
                console.log("ERR - extra from server:", serverObs.id, serverObs.obs_id, serverObs.text)
                compareOk = false
            }
        })
        if (compareOk) {
            /*
            // todo validate sort order
            // todo currently servers performs sorting only for "pdf json" as sorting is not needed for dashboard
            obsFromServer.forEach((serverObs, serverInd) => {
                let clientInd = tableRows.findIndex(obs => obs.obj_id === serverObs.obj_id)
                if (clientInd !== serverInd) {
                    console.log("ERR - order mismatch:", serverObs.id, serverObs.obs_id, serverObs.text,
                        "serverInd:", serverInd, "clientInd:", clientInd)
                    compareOk = false
                }
            })
             */
        }
        if (compareOk) {
            console.log("OK - server and client OBS list is equal")
        }
    }

    getShareOptions() {
        let menuItems = []
        let activeProject = prosConnect.getActiveProject()
        let isSendingReportsAllowed = activeProject.isAllowed(ATTR_IS_REPORTS_ALLOWED)
        let mayShowWebReportMenu = featureEnabled(FEAT_PROMPT_REPORT_REC) &&
            (activeProject.getAttr(ATTR_EXPORT_WEB_REPORT) !== STR_NO) &&
            (this.props.reportViewMode === VIEW_MODE_LIST)
        let numOfReports = activeProject
            .getSelectedReportIds(this.state.showingSearchList)
            .length
        const openBasicModal =()=> {
            let modalContent = <ShareReportsEmailModal
                showingSearchList={this.state.showingSearchList}
                numOfReports={numOfReports}
                reportViewMode={this.props.reportViewMode}
            />
            BasicModal('Tietojen jakaminen', modalContent, {
                hideDismissButton: true
            })
        }

        const pdfButtonLabel = this.getSendPdfReportsTitle(this.props.reportViewMode);

        // 2022.10.28 - disable sending PDF with "search report" until server supports cascaded #2.319
        // when this is implemented remove "this.state.showingSearchList" constrain below from table
        if(isSendingReportsAllowed && this.props.reportViewMode === VIEW_MODE_TABLE && !this.state.showingSearchList){
            menuItems.push({
                icon: 'table',
                text: pdfButtonLabel,
                action: () => this.shareSendPdf(this.props.reportViewMode),
                btnType: 'prompt'
            });
            const listPdfButtonLabel = this.getSendPdfReportsTitle(VIEW_MODE_LIST);
            menuItems.push({
                icon: 'check-list',
                text: listPdfButtonLabel,
                action: () => this.shareSendPdf(VIEW_MODE_LIST, this.props.reportViewMode),
                btnType: 'prompt'
            });
        }
        else if (isSendingReportsAllowed && this.props.reportViewMode === VIEW_MODE_LIST) menuItems.push({
            icon: 'table',
            text: pdfButtonLabel,
            action: () => this.shareSendPdf(this.props.reportViewMode),
            btnType: 'prompt'
        })
        // Currently only support group PDF reporting
        if(isSendingReportsAllowed && maySendCalendarPdf()) menuItems.push({
            icon: 'calendar-today',
            text: 'Lähetä PDF-kalenteri',
            action: ()=> this.shareSendPdf(this.props.reportViewMode),
            btnType: 'prompt'
        })
        if(isSendingReportsAllowed && mayShowWebReportMenu) menuItems.push({
            icon: 'send',
            text: 'Lähetä web-raportteja (' + numOfReports + ')',
            action: ()=> openBasicModal(true),
            btnType: 'prompt'
        })
        if (prosConnect.featureEnabled(prosConnect.FEAT_SHARE_TABLE_LINK)) {
            menuItems.push({ element: <MakeWebLinkToClipBoard
                    buttonTitle="Luo www-linkki näkymään"
                    onDone={BasicModalDismiss}
                />
            })
        }
        if(USE_DEVELOPMENT_FEATURES) menuItems.push({
            icon: 'table',
            text: 'Testaa serverin taulukon suodatus',
            action: ()=> this.testTableFilterFromServer()
        })
        return menuItems
    }

    closeAppPopups() {
        prosPopupCloseAll(this)
        this.closeSidePanel()
    }

    hideSharePopup() {
        prosPopupClose();
        setHelpContext('closePopup');
    }

    renderBookmarksMenu(){
        if (prosConnect.getActiveProject().isMyProdectProject()) {
            return null
        }
        return <BookMarksMenu
            viewMode={this.props.reportViewMode}
            openLinkToBookmark={(bookMark) => this.props.openLink(bookMark)}
            showSaveToBooksmarks={this.openGiveNameToBookmark}
        />
    }

    renderReportToolbar() {
        if (this.props.reportViewMode === VIEW_MODE_LIST) {
            return <div className={"view-options element-set-sm"}>
                {this.renderSortAllToggle()}
                {this.renderDragToggle()}
                {this.renderBookmarksMenu()}
                {this.renderRefreshUi()}
                {this.renderShareMenu()}
            </div>
        }
        if (this.props.reportViewMode === VIEW_MODE_TABLE) {
            return <div className={"view-options element-set-sm"}>
                {this.renderColumnSettingsToggle()}
                {this.renderSortingMenu()}
                {this.renderShowColumnFilters()}
                {this.renderWrapDropdown()}
                {this.renderBookmarksMenu()}
                {this.renderRefreshUi()}
                {this.renderShareMenu()}
            </div>
        }
        if ([VIEW_MODE_CALENDAR, VIEW_MODE_KANBAN].includes(this.props.reportViewMode)) {
            return <div className={"view-options element-set-sm"}>
                {this.renderBookmarksMenu()}
                {this.renderRefreshUi()}
                {this.renderShareMenu()}
            </div>
        }
    }

    renderOpenTagStripButton(amount, all){
        if(amount === 1) return null
        const label = (amount === all ? 'Kaikki' : amount + '/' + all) + ' valittu'
        return <BasicButton
            btnClass={"2nd"}
            icon={this.state.showTagStrip ? "chevron-left" : "chevron-right"}
            iconPosition={"right"}
            label={!this.state.showTagStrip && all > 0 ? label : null}
            action={()=> this.setState({showTagStrip: !this.state.showTagStrip})}
        />
    }

    renderTagStripContent(list, andMore){
        return <div
                className={andMore > 0 ? "text-sm" : null}
            >
            {list}
            {andMore > 0 ? this.renderSelectReportsButton( "(+" + andMore + " lisää...)", "xs") : null}
        </div>
    }

    renderReportToggles() {
        if (!savedUiMode.isSearchMode &&
            this.props.reportViewMode === VIEW_MODE_LIST &&
            this.state.filterTextInput !== '') {
            // Do not show report list when text filter in list mode is used
            // This avoid users to select/unselect reports as these are automatically selected
            // when have a text search match
            return null
        }
        let activeProject = prosConnect.getActiveProject()
        if (!activeProject) { return null }
        let allreports = activeProject.getReportsOrSearches(savedUiMode.isSearchMode)
        const renderReportName =(report)=> {
            if(!report) { return null }
            return <span>{prosConnect.getReportInfo(report)}</span>
        }
        if(this.state.showingSearchList) return <div id={"tag-strip"}>
            <div>
                {renderReportName(activeProject.getSelectedSearch())}
                <p className={"valign-center padding text-sm"}>
                    Haulla löytyy {this.state.previousSearchStat?.matchingObsCount} osumaa.
                </p>
            </div>
        </div>
        let reports = prosConnect.getActiveProject().getReports(false)
        if(reports.length < 1) return null
        let andMore = reports.length - MAX_REPORTS_STRIP_VISIBLE
        const listReports = reports.slice(0, MAX_REPORTS_STRIP_VISIBLE)
        let list = listReports.map((itm, i) => {
            let report = allreports.find(r => r[ATTR_OBJ_ID] === itm[ATTR_OBJ_ID])
            let isSelected = report && report.obj_type !== 'lst' ? true
                : activeProject.isReportSelected(report[ATTR_OBJ_ID])
            return <React.Fragment key={i}>
                {renderReportName(report, isSelected)}
            </React.Fragment>
        })
        let isOpen = this.state.showTagStrip || reports.length === 1
        return <div id="tag-strip" className={this.state.showTagStrip || isOpen ? " open" : ""}>
            {isOpen ? this.renderTagStripContent(list, andMore) : null}
            {this.renderOpenTagStripButton(reports.length, allreports.length)}
        </div>
    }

    clearReportSelectionNameFilterOnProjectChange(){
        if(reportSelectionPid !== this.props.activeProjectId) {
            reportSelectionPid = this.props.activeProjectId
            reportSelectionTextFilter = ''
        }
    }

    renderSelectReportsButton( label = false, size = null){
        let project = prosConnect.getActiveProject()
        let icon = true
        if(typeof label !== 'string'){
            if(label) label = 'Raportit'
        } else{
            icon = false
        }
        return <ProsReportsButton
            preSelectedReportIds={project.getSelectedReportIds(false)}
            isSearchMode={savedUiMode.isSearchMode}
            reportSelectionTextFilter={reportSelectionTextFilter}
            notif={this.notifFromReport}
            gotoPage={this.gotoPage}
            userCanAddSearches={this.uiList.length < prosConnect.featureLimit(prosConnect.FEAT_MAX_SEARCH_COUNT, 999)}
            onClose={(selectedReportIds, searchTerm, isSearchMode) => {
                setSelectedReportIds(selectedReportIds, isSearchMode)
                reportSelectionTextFilter = searchTerm
                savedUiMode.isSearchMode = isSearchMode
                this.setState({
                        showingSearchList: isSearchMode
                    }, ()=>{
                        resetPageNumber(prosConnect.getActiveProjectID())
                        this.loadDataForUi()
                })
            }}
            disabled={this.state.disableShowingReportSelection}
            label={label}
            icon={icon}
            size={size}
        />
    }

    renderFloatButton() {
        if (this.props.editLinkForTable) {
            return null
        }
        return <FloatButton />
    }

    renderMainContent() {
        return  <section className={"content content-project content-" + this.props.reportViewMode
                 + (this.state.showSidepanel ? " sidepanel-visible" : "")}
            >
            {this.props.reportViewMode !== VIEW_MODE_DASHBOARD ? <header>
                {this.renderPageHeaderInfo()}
            </header> : null}
            {this.props.reportViewMode === VIEW_MODE_LIST && this.uiList.length > 0 ?
                <div className={"view-controls"}>
                    {this.renderReportToolbar()}
                </div>
                : null}
            {this.renderUiList()}
            {this.renderFloatButton()}
            {this.renderLocationPictureList()}
            {this.renderAddNewReportOrSearch()}
        </section>
    }

    render() {
        if (!this.uiList || !prosConnect.getActiveProject()) {
            return <div className={"valign-center"}><h2 className={"text-center"}>Projektia ei ole valittu.</h2></div>
        }
        return <>
            {this.renderProjectLoadProgress()}
            {this.renderMainContent()}
            {prosPopupRender(this, "ProjectReports")}
        </>
    }
}

function ShareReportsEmailModal(props){
    const [email, setEmail] = useState(props.email)
    const [emailText, setEmailText] = useState(props.email)
    const [selectedReportType, setSelectedReportType] = useState(REPORT_TYPE_HISTORY)
    let typeContent = null

    function renderSelectReportType(reportType, label, feature) {
        if (!prosConnect.getActiveProject().mayShareWebReport(feature)) {
            return null
        }
        return <RadioButton
            checked={selectedReportType === reportType}
            text={label}
            onChange={() => setSelectedReportType(reportType)}
        />
    }

    const sendWebReport = async ()=> {
        let activeProject = prosConnect.getActiveProject()
        let selectedReports = activeProject.getSelectedReportIds(props.showingSearchList)
        let reportType = props.showingSearchList ? REPORT_TYPE_SEARCH : selectedReportType

        let emailStr = email ? email : prosConnect.getUserEmail()
        let emailError = whyEmailStringNotValid(emailStr)
        if (emailError) {
            prosAppNotifWarnConfirm(emailError)
            return
        }
        let emailReceivers = prosConnect.replaceAll(emailStr, ' ', '');
        emailReceivers = prosConnect.replaceAll(emailReceivers, ';', ',').split(',');
        BasicModalDismiss()
        prosAppNotif("Tehdään web raporttia..")

        let emailMsg = emailText && emailText.length > 0 ? emailText: PRODECT_DEFAULT_EMAIL_MSG
        let reportCount = 0
        for (let reportId of selectedReports) {
            reportCount += 1
            let response = await prosConnect.getActiveProject().awaitMakeWebReport(
                reportId,
                reportType,
                emailReceivers,
                emailMsg,
                false,
                null,
                props.reportViewMode)
            let countInfo = (selectedReports.length > 1) ?
                (reportCount.toString() + "/" + selectedReports.length.toString()) + " " : ""
            prosConnect.prosLog("Response to web report req", response)
            if (response && response.response === "OK") {
                prosAppNotif("Web raportti " + countInfo + "hetken kuluttua sähköpostissa")
            } else {
                prosAppNotifWarn("Web raportin " + countInfo  + "teko epäonnistui !")
            }
        }
    }
    if(!props.showingSearchList) typeContent = <>
        <h3>Web-raporttien tyyppi</h3>
        <div className={"selection-group selection-group-radio"}>
            {renderSelectReportType(REPORT_TYPE_HISTORY, 'Tallennettu nykytila', undefined)}
            {renderSelectReportType(REPORT_TYPE_UPDATED, 'Päivittyvä', FEAT_WEB_UPDATED)}
        </div>
    </>
    let searchReportNote = props.showingSearchList ? <h2>Päivittyvä Web-raportti</h2> : null
    let noteText
    if (props.reportViewMode === VIEW_MODE_LIST && !props.showingSearchList) {
        noteText = <p>Valittu <strong>{props.numOfReports}</strong> raporttia</p>
    }
    let modalContent = <>
        <section>
            {noteText}
            {typeContent}
            {searchReportNote}
            <TextInput
                label={"Vastaanottaja"}
                type={"email"}
                value={email}
                onChange={(val)=> setEmail(val)}
                autoFocus
                info={"Jätä tyhjäksi kun lähetät itsellesi."}
            />
            <Spacer/>
            <TextInput
                label={"Viesti"}
                multiline={5}
                value={emailText}
                onChange={(val)=> setEmailText(val)}
            />
        </section>
        <footer>
            <div className={"btn-set"}>
                <CancelButton
                    action={()=> BasicModalDismiss()}
                />
                <ConfirmButton
                    label={"Lähetä raportteja (" + props.numOfReports + ")"}
                    action={()=> sendWebReport()}
                />
            </div>
        </footer>
    </>
    return modalContent
}